/**
 * Archivo de localización: ID
 * Míster 11 - Sistema de Localización Canónico
 */

export const id = {
  "ach.biweekly_fit.desc": "Catat atau lewati rekor pribadi Anda dalam tes fisik tim.",
  "ach.biweekly_fit.name": "Evolusi Fisik",
  "ach.biweekly_iron.desc": "100% kehadiran selama 14 hari berturut-turut.",
  "ach.biweekly_iron.name": "Pemain Besi",
  "ach.biweekly_self_care.desc": "Kirimkan check-in kebugaran Anda setidaknya pada 80% hari.",
  "ach.biweekly_self_care.name": "Kebiasaan Sehat",
  "ach.biweekly_strong_mind.desc": "Selesaikan 3 tes psikologis ketahanan atau kekuatan mental.",
  "ach.biweekly_strong_mind.name": "Ketahanan Kompetisi",
  "ach.biweekly_teammate.desc": "Konfirmasikan kehadiran Anda (RSVP) ke semua acara sebelumnya.",
  "ach.biweekly_teammate.name": "Komitmen Bersama",
  "ach.gold_cone_memory.desc": "Ingat dan ulangi urutan setidaknya 6 kerucut di Memori Kerucut.",
  "ach.gold_cone_memory.name": "Memori Kejuaraan",
  "ach.gold_impulse_brake.desc": "Capai akurasi 90% atau lebih pada permainan Rem Impulsif.",
  "ach.gold_impulse_brake.name": "Rem Emas",
  "ach.gold_tactical_eye.desc": "Dapatkan 5/5 jawaban tepat di Mata Taktis dengan menemukan rekan bebas.",
  "ach.gold_tactical_eye.name": "Mata Elang",
  "ach.season_analyst.desc": "Selesaikan semua kuesioner dan evaluasi dalam katalog.",
  "ach.season_analyst.name": "Pakar Taktis & Mental",
  "ach.season_assist.desc": "Berikan umpan gol penentu kepada rekan setim Anda.",
  "ach.season_assist.name": "Penggerak Tim",
  "ach.season_captain.desc": "100% kehadiran pada latihan dan pertandingan selama sebulan penuh.",
  "ach.season_captain.name": "Jiwa Kapten",
  "ach.season_mental_squad.desc": "Pencapaian kolektif: tim mengumpulkan 20 atau lebih sesi kognitif.",
  "ach.season_mental_squad.name": "Skuad Mental",
  "ach.season_scorer.desc": "Capai target gol yang dicetak dalam kompetisi resmi.",
  "ach.season_scorer.name": "Pencetak Gol Musim Ini",
  "ach.season_unstoppable.desc": "Pertahankan konsistensi olahraga selama 21 hari berturut-turut.",
  "ach.season_unstoppable.name": "Rentetan Tak Terhentikan",
  "ach.season_veteran.desc": "Berpartisipasi atau dipanggil ke setidaknya 80% laga musim ini.",
  "ach.season_veteran.name": "Veteran Musim Ini",
  "ach.weekly_attentive.desc": "Periksa detail pertandingan dan latihan sebelum waktu pemanggilan.",
  "ach.weekly_attentive.name": "Selalu Waspada",
  "ach.weekly_committed.desc": "Selesaikan latihan dari rencana individu yang ditugaskan.",
  "ach.weekly_committed.name": "Kerja Senyap",
  "ach.weekly_mind_active.desc": "Selesaikan setidaknya 3 sesi latihan kognitif atau tantangan minggu ini.",
  "ach.weekly_mind_active.name": "Pikiran Aktif",
  "ach.weekly_perfect_week.desc": "Hadiri 100% sesi latihan yang dijadwalkan minggu ini.",
  "ach.weekly_perfect_week.name": "Minggu Sempurna",
  "ach.weekly_scholar.desc": "Selesaikan setidaknya 1 tes psikologis atau evaluasi di portal.",
  "ach.weekly_scholar.name": "Pikiran Tangguh",
  "ach.weekly_wellness.desc": "Catat tidur dan rasa pegal Anda pada hari latihan.",
  "ach.weekly_wellness.name": "Pemeriksaan Kesehatan",
  "ach.weekly_zen.desc": "Selesaikan Pernapasan 4-4 setidaknya pada 3 hari berbeda minggu ini.",
  "ach.weekly_zen.name": "Zen",
  "achievements.toast_unlocked": "Pencapaian terbuka: {name}! (+{xp} XP)",
  "admin.account_deleted": "Your pelatih akun dan data have been dihapus successfully.",
  "admin.ai.desc": "Konfigurasikan kunci API Groq agar AI Generatif berfungsi di semua perangkat (termasuk APK tablet tanpa kompilasi ulang).",
  "admin.ai.keyLabel": "Kunci API Groq (gsk_...)",
  "admin.ai.saveKey": "SIMPAN KUNCI",
  "admin.ai.title": "Konfigurasi AI (Groq)",
  "admin.already_latest": "✅ Anda sudah memasang versi terbaru (v{version}).",
  "admin.apk.desc": "Instal Mister11 langsung di tablet Android Anda",
  "admin.apk.downloadBtn": "UNDUH APK",
  "admin.apk.instructions": "Khusus Android · Aktifkan 'Sumber tidak dikenal' di pengaturan sistem sebelum menginstal",
  "admin.apk.title": "Aplikasi Android (APK)",
  "admin.apk_download_done": "✅ Unduh complete. Find the file in your Downloads folder and install it.",
  "admin.apk_download_fallback": "⚠️ Direct unduh failed. Opening alternative link...",
  "admin.apk_download_start": "⬇️ Starting APK unduh...",
  "admin.backup_error": "Kesalahan generating Kembaliup.",
  "admin.groq_api_error": "Error saving API key ke Firestore.",
  "admin.groq_api_saved": "Kunci API Groq berhasil disimpan!",
  "admin.lang.title": "Bahasa Sistem",
  "admin.manageSubAndroidMsg": "Kelola langganan Anda dari mister11.app",
  "admin.match_not_found": "Pertandingan tidak ditemukan.",
  "admin.no_active_team": "Tidak ada tim aktif yang dipilih.",
  "admin.no_players": "Tidak ada pemain di tim aktif.",
  "admin.notif.title": "Notifikasi",
  "admin.pref.checkUpdates": "Periksa pembaruan",
  "admin.pref.checking": "Memeriksa...",
  "admin.pref.darkMode": "Mode Gelap",
  "admin.pref.reminders": "Pengingat Sesi",
  "admin.pref.remindersDescApk": "Tersedia di aplikasi Android (APK).",
  "admin.pref.remindersDescNative": "Anda akan menerima pemberitahuan 1 jam sebelum setiap sesi latihan.",
  "admin.pref.systemLang": "BAHASA SISTEM",
  "admin.pref.title": "Preferensi",
  "admin.pref.version": "Versi aplikasi saat ini",
  "admin.profile_error": "Error saving profil.",
  "admin.profile_synced": "Coach profil synced across  entire system.",
  "admin.report_error": "Kesalahan generating global Laporan.",
  "admin.section.equipos": "Tim Management",
  "admin.select_match_first": "Please pilih sebuah pertandingan first.",
  "admin.select_session_first": "Pilih sesi terlebih dahulu.",
  "admin.select_team_first": "Pilih tim terlebih dahulu.",
  "admin.session_not_found": "Sesi Latihan not found.",
  "admin.settings.category": "KATEGORI",
  "admin.settings.coachProfile": "Profil Pelatih",
  "admin.settings.cookies": "Cookies",
  "admin.settings.copyConsentBtn": "🔗 Salin Tautan Persetujuan Digital",
  "admin.settings.deleteAccountGdpr": "Hapus Akun & Data (GDPR)",
  "admin.settings.downloadConsentBtn": "Unduh Persetujuan Orang Tua (Bisa Dicetak)",
  "admin.settings.fullName": "Nama Lengkap",
  "admin.settings.inviteStaffBtn": "Salin / Bagikan Tautan untuk Mengundang Pelatih",
  "admin.settings.legalDesc": "Unduh template hukum wajib dan kelola persetujuan untuk orang tua pemain di bawah umur.",
  "admin.settings.legalTitle": "Pusat Hukum & Persetujuan",
  "admin.settings.manageStaffBtn": "Lihat dan Kelola Seluruh Staf Pelatih",
  "admin.settings.primaryColor": "WARNA UTAMA",
  "admin.settings.privacy": "Privasi",
  "admin.settings.roleAnalyst": "Analis Taktis",
  "admin.settings.roleAssistant3": "Asisten / Pelatih ke-3",
  "admin.settings.roleAssistantCoach": "Pelatih Kedua",
  "admin.settings.roleFitnessCoach": "Pelatih Fisik",
  "admin.settings.roleHeadCoach": "Pelatih Utama (Admin)",
  "admin.settings.rolePhysio": "Fisioterapis / Dokter",
  "admin.settings.rolePlayer": "Pemain",
  "admin.settings.roleSpecialty": "Peran / Spesialisasi dalam Tim",
  "admin.settings.saveIdentity": "SIMPAN Identitas",
  "admin.settings.saveProfile": "SIMPAN Profil & Peran",
  "admin.settings.season": "MUSIM",
  "admin.settings.secondaryColor": "WARNA KEDUA",
  "admin.settings.subtitle": "Sesuaikan pengalaman Anda dan identitas visual klub Anda.",
  "admin.settings.teamBadge": "LOGO TIM",
  "admin.settings.teamIdentity": "Identitas Tim",
  "admin.settings.teamName": "NAMA TIM",
  "admin.settings.terms": "Ketentuan",
  "admin.settings.title": "Pengaturan Sistem",
  "admin.settings.uploadImage": "Unggah Gambar",
  "admin.shield_error": "Could not upload atau process  image.",
  "admin.shield_saved": "Lambang berhasil disimpan dan dioptimalkan!",
  "admin.svg_shield_saved": "Lambang vektor SVG berhasil disimpan!",
  "admin.tab.ajustes": "Pengaturan",
  "admin.tab.club": "Club",
  "admin.tab.ejercicios": "Latihan",
  "admin.tab.equipos": "Tims",
  "admin.tab.exportar": "Ekspor",
  "admin.tab.general": "General",
  "admin.tab.suscripcion": "Langganan",
  "admin.team_identity_error": "Error updating tim identity.",
  "admin.team_identity_updated": "Tim identity updated successfully.",
  "admin.theme.dark": "Modo Oscuro",
  "admin.title": "Panel Administrasi Klub",
  "admin.update_check_error": "Could not check untuk updates.",
  "admin.update_connect_error": "Error connecting ke  server.",
  "admin.xp.absent": "XP Absen",
  "admin.xp.desc": "Konfigurasikan poin XP yang diberikan per status kehadiran yang dikonfirmasi dan target musim tim.",
  "admin.xp.excused": "XP Izin",
  "admin.xp.goals": "Target Gol Musim",
  "admin.xp.late": "XP Terlambat",
  "admin.xp.present": "XP Hadir",
  "admin.xp.saveBtn": "Pengaturan XP",
  "admin.xp.title": "Musim & Tabel XP Terdiferensiasi",
  "admin.xp.veteran": "% Pertandingan Veteran",
  "admin.xp_error": "Kesalahan saving XP configuration.",
  "admin.xp_saved": "XP table dan season objectives disimpan successfully.",
  "analisis.btnExportPdf": "Ekspor Analysis PDF",
  "analisis.chart.axisCounterEff": "Serangan Balik Efficiency",
  "analisis.chart.axisDuels": "% Duelos",
  "analisis.chart.axisLossControl": "Kontrol Kehilangan Bola",
  "analisis.chart.axisRecoveries": "Recuperaciones",
  "analisis.chart.axisShots": "Tiros a Puerta",
  "analisis.chart.bars": "Perbandingan Langsung Peristiwa",
  "analisis.chart.duels": "% Duelos Ganados",
  "analisis.chart.losses": "Kehilangan Bola",
  "analisis.chart.radar": "Radar Profil Taktis Rata-rata",
  "analisis.chart.recoveries": "Recuperaciones",
  "analisis.chart.shotsOwn": "Tiros Propios",
  "analisis.chart.shotsOwnTitle": "Own Shots pada Target",
  "analisis.chart.shotsRival": "Tiros Rival",
  "analisis.chart.trend": "Performance Evolution dan Trend",
  "analisis.exportPdf": "Unduh PDF Analysis",
  "analisis.exportingPdf": "Generando PDF...",
  "analisis.kpi.counters": "Serangan Balikattack Efficiency",
  "analisis.kpi.countersSub": "Rasio konversi perebutan bola",
  "analisis.kpi.duels": "Duelos Ganados",
  "analisis.kpi.duelsSub": "Efektivitas duel global",
  "analisis.kpi.recLossSubAvg": "Rata-rata Rebut / Hilang",
  "analisis.kpi.recLossSubTot": "Total Rebut / Hilang",
  "analisis.kpi.recoveries": "Perebutan / Kehilangan",
  "analisis.kpi.recoveriesSub": "Rata-rata Rebut / Hilang",
  "analisis.kpi.recoveriesSubTotal": "Total Rebut / Hilang",
  "analisis.kpi.shots": "Tiros a Puerta",
  "analisis.kpi.shotsSub": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubAvg": "Prom. Propio vs Rival",
  "analisis.kpi.shotsSubTot": "Total Propio vs Rival",
  "analisis.kpi.shotsSubTotal": "Total Propio vs Rival",
  "analisis.loadingData": "Loading pertandingan events...",
  "analisis.modal.all": "Todos",
  "analisis.modal.clear": "Limpiar",
  "analisis.modal.confirm": "ACEPTAR Y COMPARAR",
  "analisis.modal.noDate": "Sin fecha",
  "analisis.modal.pending": "Pendiente",
  "analisis.modal.selectedCount": "{count} pertandingan selected",
  "analisis.modal.title": "Select Pertandingan to Compare",
  "analisis.modal.withData": "Dengan data",
  "analisis.mode.averages": "Promedios",
  "analisis.mode.title": "Metrik:",
  "analisis.mode.totals": "Totales",
  "analisis.noMatchesSelected": "Select di least 1 pertandingan ke perform comparative analysis",
  "analisis.selectMatches": "Select Pertandingan",
  "analisis.shortcuts.allSeason": "Sepanjang Musim",
  "analisis.shortcuts.last3": "3 Terakhir",
  "analisis.shortcuts.last5": "5 Terakhir",
  "analisis.shortcuts.title": "ATAJOS:",
  "analisis.subtitle": "Tactical evolution, shots, duels dan recoveries throughout  season",
  "analisis.table.cards": "Tarjetas (A / R)",
  "analisis.table.duels": "Duelos %",
  "analisis.table.fouls": "Faltas (F / C)",
  "analisis.table.match": "Laga / Lawan",
  "analisis.table.recLoss": "Reb / Hil",
  "analisis.table.result": "Resultado",
  "analisis.table.shots": "Tiros (P / R)",
  "analisis.table.title": "Rincian per Pertandingan",
  "analisis.title": "Analisis Performa & Video",
  "app.copyright": "2026 Mister11 · {slogan}",
  "app.slogan": "bench di your pocket",
  "attendance.banner.closeMatchSheet": "Tutup Berita Acara",
  "attendance.banner.completeSession": "📋 Selesaikan Sesi",
  "attendance.banner.unclosedEvents": "Anda memiliki {sessions} sesi{sPlural} belum dicatat dan {matches} pertandingan{mPlural} terbuka.",
  "attendance.banner.unclosedSubtitle": "Lengkapi dan tutup untuk meresmikan % kehadiran dan menit bermain pemain.",
  "attendance.btn.exportPdf": "📄 Ekspor PDF",
  "attendance.callup.activeWindow": "Jendela Evaluasi Aktif",
  "attendance.callup.consider": "Pertimbangkan",
  "attendance.callup.notRecommended": "Tidak direkomendasikan",
  "attendance.callup.recommended": "Direkomendasikan",
  "attendance.callup.subtitle": "Metrik kehadiran nyata pada sesi terjadwal untuk memandu panggilan pertandingan berikutnya.",
  "attendance.callup.thBreakdown": "Rincian (H / T / I / A / BC)",
  "attendance.callup.thGuidance": "Panduan",
  "attendance.callup.thPct": "% Jendela",
  "attendance.callup.thPlayer": "Pemain",
  "attendance.callup.thStreak": "🔥 Rekor",
  "attendance.callup.title": "🎯 Asisten Panggilan Berdasarkan Kehadiran",
  "attendance.callup.window.biweekly": "14 Hari Terakhir",
  "attendance.callup.window.microcycle": "Mikrosiklus",
  "attendance.callup.window.season": "Musim",
  "attendance.callup.window.week": "Minggu Ini",
  "attendance.chart.filtersTitle": "Seri Grafik & Penjelasan (Klik untuk Tampilkan/Sembunyikan)",
  "attendance.chart.guide.example": "Currently your tim averages {avg}% attendance across {count} recorded events.",
  "attendance.chart.guide.step1": "1. Each point is sebuah latihan atau pertandingan: ordered chronologically.",
  "attendance.chart.guide.step2": "2.  green line is your attendance: above 70% you are pada track.",
  "attendance.chart.guide.step3": "3. If red rises while green drops: there is sebuah commitment issue ke address.",
  "attendance.chart.guide.step4": "4. Tap any point ke view details dan open its register directly.",
  "attendance.chart.guide.title": "Cara membaca grafik ini?",
  "attendance.chart.guideCoach": "Panduan Interpretasi untuk Staf Pelatih",
  "attendance.chart.guideStep1": "1. Garis Waktu & Peristiwa",
  "attendance.chart.guideStep2": "2. Garis Hijau",
  "attendance.chart.guideStep3": "3. Persilangan Peringatan",
  "attendance.chart.guideStep4": "4. Ketuk untuk Rincian",
  "attendance.chart.legend.absent": "Ausentes",
  "attendance.chart.legend.absent.desc": "Unexcused absences. Should aim untuk zero.",
  "attendance.chart.legend.attendance": "Kehadiran Nyata (H+T)",
  "attendance.chart.legend.attendance.desc": "Pemain who attended (present + late). The higher, the better.",
  "attendance.chart.legend.justified": "Justificados",
  "attendance.chart.legend.justified.desc": "Justified notices. Does not penalize  main %.",
  "attendance.chart.legend.late": "Tardes",
  "attendance.chart.legend.late.desc": "Llegadas tarde. Vigila si sube varias semanas seguidas.",
  "attendance.chart.legend.official": "Official (closed sheet/sesi)",
  "attendance.chart.legend.provisional": "Provisional (open sheet/sesi)",
  "attendance.chart.legend.threshold70": "Ambang batas peringatan (70%): di bawahnya, risiko panggilan.",
  "attendance.chart.noData": "Belum ada data kehadiran sesi atau pertandingan yang tercatat.",
  "attendance.chart.openRegister": "Buka Catatan Kehadiran",
  "attendance.chart.summaryStats": "Pilihed Event Ringkasan",
  "attendance.chart.title": "Tim Attendance Evolution",
  "attendance.markAllPresent": "Tandai Semua Hadir",
  "attendance.register.closingSheet": "Menutup Laporan...",
  "attendance.register.customNew": "+ Tanggal Kehadiran Kustom Baru",
  "attendance.register.date": "Tanggal",
  "attendance.register.excludeTitle": "Mengecualikan sesi ini dari perhitungan kehadiran seluruh skuad",
  "attendance.register.expected": "⚽ Diharapkan: {attended} dari {total}",
  "attendance.register.extraSession": "Sesi Tambahan",
  "attendance.register.futureSession": "🕐 Sesi mendatang",
  "attendance.register.markAllPresent": "Tandai Semua Hadir",
  "attendance.register.markSuspended": "Tandai Ditunda",
  "attendance.register.matchSheetClosed": "📋 Berita Acara Resmi Ditutup",
  "attendance.register.matchSheetOpen": "⏳ Berita Acara Terbuka",
  "attendance.register.officialNote": "✅ Resmi · dikonfirmasi oleh pelatih",
  "attendance.register.officialSaved": "✅ Catatan resmi tersimpan",
  "attendance.register.pendingRegistration": "⏳ Menunggu pencatatan",
  "attendance.register.prefillRsvp": "⚡ Isi otomatis dari RSVP",
  "attendance.register.prefillTooltip": "Isi otomatis dari tanggapan RSVP pemain tanpa menimpa perubahan manual",
  "attendance.register.provisionalNote": "⏳ Sementara · sesuai respons pemain (ketuk untuk konfirmasi)",
  "attendance.register.reopenSheet": "🔓 Buka Kembali Berita Acara",
  "attendance.register.rsvpLiveTitle": "📲 Respons RSVP Pemain & Perencanaan (langsung)",
  "attendance.register.saveAndCloseSheet": "Simpan & Tutup Berita Acara",
  "attendance.register.saveAttendance": "Simpan Kehadiran",
  "attendance.register.selectEvent": "Pilih Sesi Latihan atau Pertandingan:",
  "attendance.register.sessionsAndMatches": "Sesi dan Pertandingan",
  "attendance.register.suspendedActive": "Ditunda (Aktif)",
  "attendance.register.suspendedSession": "🌧️ Sesi Ditunda",
  "attendance.register.title": "Judul",
  "attendance.register.updateNotice": "ℹ️ Anda dapat mengubah presensi kapan saja; langsung terbarui",
  "attendance.rsvp.going": "Akan hadir",
  "attendance.rsvp.justified": "Izin",
  "attendance.rsvp.late": "Datang terlambat",
  "attendance.rsvp.none": "Tanpa jawaban",
  "attendance.rsvp.not_going": "Tidak hadir",
  "attendance.saveBtn": "Simpan Attendance",
  "attendance.saveError": "Kesalahan saving attendance. Please try again.",
  "attendance.saveSuccess": "Attendance disimpan successfully.",
  "attendance.saving": "Menyimpan...",
  "attendance.status.absent": "Absen",
  "attendance.status.injured": "Cedera",
  "attendance.status.justified": "Izin",
  "attendance.status.late": "Terlambat",
  "attendance.status.present": "Hadir",
  "attendance.status.unmarked": "Belum dicatat",
  "attendance.summary.acceptable": "✓ Dapat Diterima",
  "attendance.summary.noData": "⚪ Tanpa data",
  "attendance.summary.optimal": "✓ Optimal",
  "attendance.summary.risk": "⚠️ Risiko",
  "attendance.summary.sortBy": "Urutkan berdasarkan:",
  "attendance.summary.sortName": "Nama",
  "attendance.summary.sortNumber": "Nomor Punggung",
  "attendance.summary.sortPctAsc": "% Kehadiran (Terendah ke Tertinggi)",
  "attendance.summary.sortPctDesc": "% Kehadiran (Tertinggi ke Terendah)",
  "attendance.summary.thAbsent": "Absen",
  "attendance.summary.thAttendance": "% Kehadiran",
  "attendance.summary.thInjured": "Cedera",
  "attendance.summary.thJustified": "Izin",
  "attendance.summary.thLate": "Terlambat",
  "attendance.summary.thNoRecord": "BC",
  "attendance.summary.thPresent": "Hadir",
  "attendance.summary.thStatus": "Status",
  "attendance.summary.threshold": "Ambang Batas Peringatan:",
  "attendance.summary.title": "👥 Ringkasan Kehadiran Skuad ({count} pemain)",
  "attendance.tab.callup": "🎯 Asisten Panggilan",
  "attendance.tab.register": "📋 Catatan per Sesi",
  "attendance.tab.summary": "📊 Ringkasan Skuad",
  "attendance.tab.trend": "📈 Tren Kehadiran",
  "attendance.toast.allMarkedPresent": "Semua ditandai hadir (Resmi)",
  "attendance.toast.errorClosing": "Kesalahan saat menutup laporan resmi",
  "attendance.toast.errorReopening": "Kesalahan saat membuka kembali laporan",
  "attendance.toast.errorSaving": "Kesalahan saat menyimpan kehadiran",
  "attendance.toast.noResponses": "Belum ada tanggapan pemain",
  "attendance.toast.savedSuccess": "Kehadiran berhasil disimpan",
  "attendance.toast.selectFirst": "Pilih sesi atau pertandingan terlebih dahulu",
  "attendance.toast.sheetClosed": "Laporan resmi ditutup dan menit dihitung",
  "attendance.toast.sheetReopened": "Laporan pertandingan dibuka kembali untuk diedit",
  "attendance.toast.suspendedSaved": "Sesi ditandai ditangguhkan dan disimpan",
  "auth.coachRole": "I am Pelatih / Staff",
  "auth.email": "Email",
  "auth.forgotPass": "Lupa kata sandi?",
  "auth.googleBtn": "Continue dengan Google",
  "auth.hasAccount": "Sudah punya akun?",
  "auth.joinBtn": "Kirim Permintaan",
  "auth.joinTeam": "Gabung ke Tim",
  "auth.loginBtn": "MASUK",
  "auth.loginLink": "Masuk",
  "auth.loginTitle": "Masuk ke Mister11",
  "auth.logout": "Cerrar Sesi",
  "auth.noAccount": "Belum punya akun?",
  "auth.parentRole": "Soy Padre / Tutor",
  "auth.password": "Kata Sandi",
  "auth.playerRole": "I am Pemain",
  "auth.registerLink": "Daftar gratis",
  "auth.registerTitle": "Buat Akun",
  "auth.switched_coach": "Switched ke Coach Mode",
  "auth.switched_player": "Switched to Pemain Portal",
  "auth.teamCode": "Kode Undangan (6 digit)",
  "block.abp": "Bola Mati",
  "block.physical": "Fisik",
  "block.tactical": "Taktik",
  "block.technical": "Teknis",
  "block.warmup": "Pemanasan",
  "board.actions.delete": "BERSIHKAN",
  "board.actions.hideRival": "👁 SEMBUNYIKAN LAWAN",
  "board.actions.showRival": "👁 TAMPILKAN LAWAN",
  "board.actions.title": "AKSI",
  "board.export.encodingProgress": "Codificando video MP4...",
  "board.export.encodingTitle": "Eksporing MP4 Video",
  "board.exportModal.btnCancel": "BATAL",
  "board.exportModal.btnDownload": "DESCARGAR",
  "board.exportModal.btnExport": "EXPORT",
  "board.exportModal.btnReset": "Restablecer encuadre",
  "board.exportModal.btnShare": "SHARE",
  "board.exportModal.closeModal": "Tutup modal",
  "board.exportModal.completedDesc": "file has been processed dan disimpan successfully.",
  "board.exportModal.completedTitle": "Ekspor Completed!",
  "board.exportModal.exportPath": "Ruta / Destino",
  "board.exportModal.failed": "Error during ekspor. Click ke retry.",
  "board.exportModal.format": "Ekspor Format",
  "board.exportModal.framingTitle": "Pembingkaian & Pratinjau",
  "board.exportModal.landscape": "Horizontal (Lanskap)",
  "board.exportModal.loadingPreview": "Memuat animation preview...",
  "board.exportModal.metaDuration": "Perkiraan durasi",
  "board.exportModal.metaSize": "Perkiraan ukuran",
  "board.exportModal.metaTitle": "Judul file",
  "board.exportModal.oneFrame": "1 Fotograma",
  "board.exportModal.orientation": "Orientasi",
  "board.exportModal.portrait": "Vertikal (Potret)",
  "board.exportModal.preparing": "Menyiapkan bingkai untuk dirender...",
  "board.exportModal.quality": "Kualitas / Resolusi",
  "board.exportModal.shared": "¡Compertandingan!",
  "board.exportModal.speed": "Kecepatan Pemutaran",
  "board.exportModal.subtitle": "Configure ekspor parameters dan preview frame framing",
  "board.exportModal.title": "Ekspor Tactical Animation",
  "board.exportModal.zoomIn": "Acercar",
  "board.exportModal.zoomOut": "Alejar",
  "board.fields.blank": "Papan Kosong",
  "board.fields.f7": "Sepak Bola 7 (65x45m)",
  "board.fields.f8": "Sepak Bola 8 (62x46m)",
  "board.fields.full": "Lapangan Penuh",
  "board.fields.futsal": "Futsal (40x20m)",
  "board.fields.halfAttack": "½ Menyerang",
  "board.fields.halfDefense": "½ Bertahan",
  "board.fields.penaltyArea": "Kotak Penalti",
  "board.fields.reduced": "Lapangan Mini",
  "board.fields.thirdAttack": "Sepertiga Menyerang",
  "board.fields.thirdDefense": "Sepertiga Bertahan",
  "board.fields.thirdMid": "Sepertiga Tengah",
  "board.mat.aro": "Ring Kelincahan",
  "board.mat.balon": "Bola Sepak",
  "board.mat.balon_movimiento": "Bola Bergerak",
  "board.mat.balon_negro": "Bola Hitam",
  "board.mat.banderin": "Bendera Sudut",
  "board.mat.cono": "Kerucut",
  "board.mat.cono_amarillo": "Kerucut Kuning",
  "board.mat.cono_negro": "Kerucut Hitam",
  "board.mat.cono_rojo": "Kerucut Merah",
  "board.mat.escalera": "Tangga Kelincahan",
  "board.mat.flecha_ataque_h": "Panah Serangan Horizontal",
  "board.mat.flecha_ataque_v": "Panah Serangan Vertikal",
  "board.mat.grupo_balones": "Kumpulan Bola",
  "board.mat.grupo_conos": "Grup 3 Kerucut",
  "board.mat.grupo_conos_arco": "Busur 5 Kerucut",
  "board.mat.grupo_conos_linea": "Garis 5 Kerucut",
  "board.mat.indicador_espacio": "Indikator Ruang",
  "board.mat.jugador_camiseta": "Jersey Pemain",
  "board.mat.jugador_triangulo": "Triangle Pemain",
  "board.mat.linea_distancia": "Garis Jarak",
  "board.mat.mini_cono": "Kerucut Mini",
  "board.mat.pared_rebote": "Papan Pantul",
  "board.mat.peto": "Rompi Latihan",
  "board.mat.pica": "Tiang Kelincahan",
  "board.mat.platillo": "Kerucut Mangkok",
  "board.mat.porteria_grande": "Gawang Besar",
  "board.mat.porteria_lateral": "Gawang Samping",
  "board.mat.porteria_pequena": "Gawang Kecil",
  "board.mat.poste": "Boneka Halangan",
  "board.mat.valla": "Rintangan Lompat",
  "board.mat.zona_circular": "Zona Lingkaran",
  "board.mat.zona_grid": "Kotak 3x3",
  "board.mat.zona_rectangular": "Zona Persegi Panjang",
  "board.mat.zona_rombo": "Zona Belah Ketupat",
  "board.mat.zona_triangular": "Zona Segitiga",
  "board.matCat.balon": "BOLA",
  "board.matCat.coordinacion": "KOORDINASI",
  "board.matCat.jugadores": "PEMAIN",
  "board.matCat.material": "PERALATAN",
  "board.matCat.medidas": "UKURAN",
  "board.matCat.porteria": "GAWANG",
  "board.matCat.señalizacion": "PENANDA & KERUCUT",
  "board.matCat.zonas": "ZONA",
  "board.panels.materials": "Material",
  "board.panels.teams": "Tims",
  "board.panels.teamsAndFormations": "Tims & Formations",
  "board.stroke.fine": "Tipis",
  "board.stroke.medium": "Sedang",
  "board.stroke.thick": "Tebal",
  "board.teams.apply": "TERAPKAN",
  "board.teams.local": "Utama",
  "board.teams.rival": "Lawan",
  "board.teams.title": "TIM",
  "board.teams.wildcard": "Netral",
  "board.timeline.addFrame": "Tambah bingkai",
  "board.timeline.deleteFrame": "Hapus frame",
  "board.timeline.export": "Ekspor",
  "board.timeline.exportAnimation": "Ekspor animation",
  "board.timeline.firstFrame": "Primer fotograma",
  "board.timeline.frameLabel": "Bingkai",
  "board.timeline.lastFrame": "Bingkai terakhir",
  "board.timeline.nextFrame": "Siguiente fotograma",
  "board.timeline.play": "Reproducir",
  "board.timeline.playAria": "Putar animasi",
  "board.timeline.prevFrame": "Fotograma anterior",
  "board.timeline.stop": "Detener",
  "board.timeline.stopAria": "Hentikan pemutaran",
  "board.tool.straight_dashed_line": "Garis lurus putus-putus",
  "board.tool.zone_hexagon": "Zona hexagonal",
  "board.tool.zone_pentagon": "Zona pentagonal",
  "board.toolbar.clearCanvas": "Bersihkan entire canvas",
  "board.toolbar.exportMp4": "EXPORTAR MP4",
  "board.toolbar.exportingMp4": "REC... EksporING MP4",
  "board.toolbar.fieldType": "Tipe lapangan",
  "board.toolbar.fullscreen": "Layar Penuh",
  "board.toolbar.height": "Alto",
  "board.toolbar.new": "NEW",
  "board.toolbar.redo": "Rehacer",
  "board.toolbar.resetZoom": "Reiniciar Zoom",
  "board.toolbar.save": "SIMPAN",
  "board.toolbar.sides": "Sisi",
  "board.toolbar.strokeColor": "Warna Garis",
  "board.toolbar.strokeWidth": "Ketebalan Garis",
  "board.toolbar.swapSides": "Tukar sisi tim",
  "board.toolbar.undo": "Deshacer",
  "board.toolbar.width": "Ancho",
  "board.toolbar.zoomIn": "Acercar",
  "board.toolbar.zoomOut": "Alejar",
  "bottomnav.admin": "Admin",
  "bottomnav.ajustes": "Pengaturan",
  "bottomnav.equipo": "Tim",
  "bottomnav.home": "Beranda",
  "bottomnav.ia": "AI",
  "bottomnav.more": "Lainnya",
  "bottomnav.moreModules": "Modul & Manajemen",
  "bottomnav.partidos": "Pertandingan",
  "bottomnav.pizarra": "Papan",
  "bottomnav.planificacion": "Perencanaan",
  "bottomnav.sesiones": "Sesi Latihan",
  "bottomnav.tests": "Tes",
  "btn.add": "TAMBAH",
  "btn.back": "KEMBALI",
  "btn.cancel": "BATAL",
  "btn.close": "TUTUP",
  "btn.confirm": "KONFIRMASI",
  "btn.delete": "HAPUS",
  "btn.deleteAccount": "Hapus Account & Data (GDPR)",
  "btn.edit": "EDIT",
  "btn.export": "EKSPOR PDF",
  "btn.filter": "FILTER",
  "btn.save": "SIMPAN",
  "btn.search": "CARI",
  "capture.criteria.downloadPdf": "Unduh Official PDF",
  "capture.criteria.search": "Cari criterion...",
  "capture.criteria.title": "Panduan Kriteria Pencatatan",
  "capture.hud.advanced": "Avanzado",
  "capture.hud.duel_lost": "Duelo Perdido",
  "capture.hud.duel_won": "Duelo Ganado",
  "capture.hud.foul": "Falta",
  "capture.hud.key_pass": "Pase Clave",
  "capture.hud.recovery": "Perebutan Bola",
  "capture.hud.shot": "Tiro",
  "capture.hud.turnover": "Kehilangan Bola",
  "capture.hud.unattributed": "Sin atribuir",
  "capture.refine_btn": "Perbaiki atribusi",
  "capture.refine_empty": "Nothing tertunda ✅",
  "capture.refine_prompt_title": "Perbaiki atribusi individu sekarang? (opsional)",
  "capture.refine_skip": "Omitir",
  "capture.refine_subtitle": "Tim totals are already computed. Assign only what you want to reflect on ratings, radars, and XP.",
  "capture.refine_title": "Perbaiki atribusi individu (opsional)",
  "capture.team.shot_own": "Tiro Propio",
  "capture.team.shot_rival": "Tiro Rival",
  "charts.guide.bars": "Quantitative comparison of  10 key gameplay metrics.",
  "charts.guide.momentum": "Evolution of pertandingan dominance dan control di 15-minute intervals.",
  "charts.guide.radar": "Visualizes tactical balance across 6 dimensions between own tim dan opponent.",
  "charts.guide.shots": "Shot distribution dan expected goals (xG) probability model.",
  "charts.guide.zones": "Territorial distribution of tim interventions across 9 pitch zones.",
  "charts.insights.defensive_alert": "Defensive Alert: Opponent generated clear chances dengan high shooting comfort.",
  "charts.insights.dominant_zone": "Dominant Zone: Over 40% of actions concentrated di ini area.",
  "charts.insights.finishing_deficit": "Finishing Efficiency: High volume of scoring chances dengan deficit di conversion vs generated xG.",
  "charts.pass_insufficient_tooltip": "At least 5 recorded passes required ke generate tactical pass network.",
  "charts.view.pass_network": "Jaringan Umpan",
  "charts.view.territorial_map": "Mapa Territorial",
  "chat.notif_from_player": "💬 Pesan dari {playerName}: \"{msgText}\"",
  "club.team_create_error": "Error creating club tim.",
  "club.team_created": "Club tim created successfully.",
  "club.teams_assign_error": "Error assigning tim.",
  "club.teams_assigned": "Tims assigned Berhasilfully.",
  "cognitive.active_challenges_title": "Tantangan & Permainan Aktif Direkomendasikan ({count}):",
  "cognitive.assign_error": "Kesalahan saving assignments",
  "cognitive.assigned_success": "✔ {count} recommendation(s) assigned Berhasilfully",
  "cognitive.btn_recommend_challenge": "Rekomendasikan Tantangan",
  "cognitive.btn_verified": "✔ Verificado (+5 XP)",
  "cognitive.btn_verifying": "Lihatificando…",
  "cognitive.cat.alevin": "U-12",
  "cognitive.cat.benjamin": "U-10",
  "cognitive.cat.cadete": "U-16",
  "cognitive.cat.infantil": "U-14",
  "cognitive.cat.juvenil_adulto": "Juvenil / Adulto",
  "cognitive.category_label": "Kategori: {cat}",
  "cognitive.delete_recommendation": "Hapus recommendation",
  "cognitive.deselect_all": "Desmarcar todos",
  "cognitive.game.decision": "Keputusan 1\"",
  "cognitive.game.freno": "Freno",
  "cognitive.game.memoria": "Memoria",
  "cognitive.game.ojo": "Mata Taktis",
  "cognitive.game.respiracion": "Pernapasan 4-4",
  "cognitive.game.semaforo": "Lampu Lalu Lintas",
  "cognitive.level_by_game_title": "Tingkat per Permainan (Adaptif)",
  "cognitive.metric_avg_accuracy": "Akurasi rata-rata",
  "cognitive.metric_median_reaction": "Median reaksi",
  "cognitive.metric_sessions_week": "Sesi Latihan this week",
  "cognitive.metric_trend": "Tendencia",
  "cognitive.modal_assign_title": "⭐ Assign Challenges atau Games",
  "cognitive.modal_cog_games": "🧠 Kognitif Games ({count}/{Total}):",
  "cognitive.modal_confirm_assign": "Konfirmasi {count} assignment(s)",
  "cognitive.modal_entire_team": "Entire tim roster",
  "cognitive.modal_home_retos": "⚽ Tantangan Rumah ({count}/{total}):",
  "cognitive.modal_only_player": "Solo {name}",
  "cognitive.modal_recipient_label": "Destinatario:",
  "cognitive.modal_select_min": "Pilih setidaknya satu tantangan atau permainan",
  "cognitive.recommendation_deleted": "Rekomendasi dihapus",
  "cognitive.select_all": "Marcar todos",
  "cognitive.supervision_title": "Supervisi Kognitif & Tantangan Rumah",
  "cognitive.target_player": "Individual",
  "cognitive.target_team": "Todo el tim",
  "cognitive.trend_improving": "↑ Meningkat",
  "cognitive.trend_stable": "= Estable",
  "cognitive.verified_xp": "✔ Challenges verified: +5 XP assigned ke {nama}",
  "cognitive.verify_error": "Gagal mencatat verifikasi",
  "cognitive.week_sessions": "Current week · {count} recorded sesi",
  "common.absent": "Absen",
  "common.all": "SEMUA",
  "common.away": "Tandang",
  "common.back": "Kembali",
  "common.cancel": "Batal",
  "common.close": "Tutup",
  "common.closeMenu": "Tutup menu",
  "common.delete": "Hapus",
  "common.edit": "Editar",
  "common.email": "Email",
  "common.errorGeneral": "Terjadi kesalahan tak terduga",
  "common.excused": "Izin",
  "common.friendly": "Persahabatan",
  "common.genericError": "Kesalahan operasi",
  "common.home": "Beranda",
  "common.injured": "Cedera",
  "common.loading": "Memuat...",
  "common.matchTag": "Pertandingan",
  "common.myTeam": "Tim Saya",
  "common.no": "Tidak",
  "common.noData": "Tidak ada data",
  "common.official": "Resmi",
  "common.optimal": "Optimal",
  "common.originalBadgeEn": "Asli EN",
  "common.originalBadgeEs": "Original ES",
  "common.originalLanguage": "Bahasa asli",
  "common.originalLanguageEn": "Bahasa asli: Inggris",
  "common.originalLanguageEs": "Bahasa asli: Spanyol",
  "common.player": "Pemain",
  "common.present": "Hadir",
  "common.risk": "Risiko",
  "common.rival": "Lawan",
  "common.save": "Simpan",
  "common.savedSuccess": "Berhasil disimpan",
  "common.saving": "Menyimpan...",
  "common.sessionTag": "Sesi",
  "common.starter": "Titular",
  "common.substitute": "Cadangan",
  "common.success": "Operasi berhasil diselesaikan",
  "common.training": "Latihan",
  "common.yes": "Ya",
  "consent.authAvatar": "Photo atau identifying avatar of  pemain di line-ups dan tactical board",
  "consent.authBiometric": "Anthropometric sheet (height dan body weight untuk physical monitoring dan BMI)",
  "consent.authDob": "Date of birth (Required untuk automatic age dan category calculation)",
  "consent.authExercises": "Assignment of recovery dan individual latihan plans",
  "consent.authInjuries": "Clinical history of suffeMerah injuries (medical health data - GDPR Art. 9)",
  "consent.authName": "Full nama (Required untuk pemain profil)",
  "consent.authPhysicalTests": "Fitness dan performance physical test results",
  "consent.authPosition": "Sport position dan assigned jersey number",
  "consent.authPsychosocial": "Psychosocial questionnaires dan daily wellness tests (fatigue, sleep, stress, mood)",
  "consent.authSessions": "Attendance dan participation records di pertandingan, line-ups dan technical reports",
  "consent.clearSig": "Hapus tanda tangan",
  "consent.coachNameLabel": "Head Pelatih / Responsible",
  "consent.coachNamePlaceholder": "Nama Pelatih",
  "consent.detailsTitle": "Rincian Persetujuan",
  "consent.errBasicAuth": "It is mandatory ke authorize  processing of nama dan tanggal of birth ke register  pemain di  app.",
  "consent.errParentDni": "Guardian ID/Operanport is Wajib.",
  "consent.errParentName": "Parent/guardian nama is required.",
  "consent.errPlayerDob": "Pemain date of birth is required.",
  "consent.errPlayerName": "Pemain name (underage) is required.",
  "consent.errSig": "Please draw your digital signature di  box before proceeding.",
  "consent.footerLegal": "Mister11 does not store your contact data, signature, atau PDF file di its databases.  PDF document is processed temporarily dan instantly di  memory of your own mobile/computer browser.  legal custody of  signed PDF document rests entirely dengan  parents/guardians dan  pelatih di charge of tim management.",
  "consent.heading": "Consentimiento Parental Digital",
  "consent.instructions": "Fill di  required information. Fields marked dengan (*) are mandatory.",
  "consent.notifyWhatsapp": "Beri tahu pelatih via WhatsApp",
  "consent.parentDniLabel": "ID / NIE / Operanport *",
  "consent.parentDniPlaceholder": "Ej. 12345678Z",
  "consent.parentNameLabel": "Nama Wali *",
  "consent.parentNamePlaceholder": "Nombre y Apellidos",
  "consent.parentPhoneLabel": "Nomor Telepon Kontak",
  "consent.parentPhonePlaceholder": "Ej. +34 600 000 000",
  "consent.playerDobLabel": "Tanggal Lahir *",
  "consent.playerNameLabel": "Pemain Name *",
  "consent.playerNamePlaceholder": "Nombre y Apellidos",
  "consent.privacyDesc": "This document has been generated locally. Mister11 does not store copies of your signature atau consent pada its servers. Send  downloaded PDF ke  pelatih via WhatsApp ke keep it safely.",
  "consent.privacyTitle": "PEMBERITAHUAN PRIVASI",
  "consent.redownloadPdf": "Unduh PDF Again",
  "consent.relationFather": "Padre",
  "consent.relationGuardian": "Legal Guardian / ReHadirative",
  "consent.relationLabel": "Parentesco *",
  "consent.relationMother": "Madre",
  "consent.seasonLabel": "Musim",
  "consent.sec1": "1. Parent atau Legal Guardian Details",
  "consent.sec2": "2. Underage Pemain Details",
  "consent.sec3": "3. Tim and Coach Details",
  "consent.sec4": "4. Otorisasi Data Pribadi",
  "consent.sec4Desc": "Select what data you authorize ke be processed di Mister11 oleh  coaching staff:",
  "consent.sec5": "5. Pernyataan Persetujuan Tegas",
  "consent.sec5Text": "Hereby, acting as father, mother atau legal guardian of  underage pemain indicated above, I declare itu I have been transparently informed about  purpose dan processing of  sports dan wellness data of  pemain pada  Mister11 platform. I grant my express consent ke  processing of  boxes checked above.",
  "consent.sec6": "6. Tanda Tangan Digital Wali",
  "consent.sigLabel": "Draw your Signature dengan Finger atau Mouse *",
  "consent.subTitle": "Informed authorization untuk  sports management of  underage pemain.",
  "consent.submitBtn": "Sign dan Generate PDF Document",
  "consent.submittingBtn": "Generando PDF firmado...",
  "consent.successDesc": "parental consent document untuk pemain {nama} has been generated dan downloaded ke your device successfully.",
  "consent.successTitle": "Berhasilfully Signed!",
  "consent.teamNameLabel": "Tim / Club",
  "consent.teamNamePlaceholder": "Tim Name",
  "consent.whatsappMsg": "Hello pelatih, I have already selesai dan digitally signed  parental consent untuk {nama}. I downloaded  signed PDF ke my device. I will bagikan it dengan you next.",
  "convocation.allRecipientsSelected": "Todos seleccionados",
  "convocation.cleanSelection": "Bersihkan pilihan",
  "convocation.coachLabel": "Pelatih / ENTRENADOR",
  "convocation.competition": "Kompetisi",
  "convocation.counter": "{count}/18 Pilihed",
  "convocation.defaultMessage": "Call-up squad untuk  pertandingan vs {opponent}. Please check  details.",
  "convocation.download": "Unduh PNG",
  "convocation.downloading": "Descargando...",
  "convocation.generate": "Generar convocatoria PNG",
  "convocation.generatedWith": "Generated dengan Mister11",
  "convocation.generating": "Generando PNG...",
  "convocation.limitReached": "Limit reached: maximum 18 pemain selected",
  "convocation.matchInfo.convocationTime": "Call-up waktu (-1h)",
  "convocation.matchInfo.date": "Fecha",
  "convocation.matchInfo.location": "Lugar",
  "convocation.matchInfo.matchTime": "Pertandingan time",
  "convocation.matchInfo.rival": "Rival",
  "convocation.message": "Pesan pengumuman",
  "convocation.missingPlayersWarning": "18 pemain are recommended untuk sebuah full squad call-up.",
  "convocation.noMatchSelected": "No upcoming pertandingan scheduled.",
  "convocation.noPlayersSelected": "You have not selected any pemain.",
  "convocation.positions.def": "DEFENSAS",
  "convocation.positions.fwd": "DELANTEROS",
  "convocation.positions.gk": "PORTEROS",
  "convocation.positions.mid": "MEDIOCAMPISTAS",
  "convocation.positionsEn.def": "DEFENDERS",
  "convocation.positionsEn.fwd": "FORWARDS",
  "convocation.positionsEn.gk": "GOALKEEPERS",
  "convocation.positionsEn.mid": "MIDFIELDERS",
  "convocation.previewTitle": "Pratinjau Panggilan",
  "convocation.quickAccess": "Next pertandingan convocation",
  "convocation.regenerate": "Regenerar / Editar",
  "convocation.round": "Jornada",
  "convocation.selectPlayers": "Select called-up pemain",
  "convocation.send": "Enviar",
  "convocation.sendError": "Kesalahan Kiriming convocation.",
  "convocation.sendModalTitle": "Send Convocation to Pemain",
  "convocation.sendSuccess": "Convocation sent ke pemain successfully.",
  "convocation.sendToPlayers": "Enviar a pemaines",
  "convocation.sending": "Enviando...",
  "convocation.tab": "Convocatoria",
  "convocation.title": "Pemanggilan Pertandingan",
  "csv.browseFile": "Seleccionar Archivo",
  "csv.confirmImport": "Konfirmasi and Impor Pemain",
  "csv.continueToPreview": "Continue ke Preview",
  "csv.downloadTemplate": "Unduh CSV Template",
  "csv.dropzoneDesc": "File yang didukung: .csv, .xlsx, .xls (maks. 5MB)",
  "csv.dropzoneTitle": "Drag dan drop your file here atau click ke browse",
  "csv.errorDuplicateNumberFile": "Duplicate shirt number within  file.",
  "csv.errorDuplicateNumberTeam": "Shirt number is already taken di ini tim.",
  "csv.errorEmptyFile": "selected file is empty.",
  "csv.errorInvalidNumber": "Shirt number must be sebuah integer between 1 dan 99.",
  "csv.errorInvalidPosition": "Invalid position. Use GK, DEF, MID, FWD atau equivalent.",
  "csv.errorMissingName": "Pemain name is required.",
  "csv.errorParsing": "Could not read file. Check CSV atau Excel formatting.",
  "csv.errorPlanLimitExceeded": "You have reached  maximum pemain allowed oleh your plan.",
  "csv.errorUnsupportedFormat": "Unsupported format. Use .csv atau .xlsx files.",
  "csv.fieldBirthDate": "Tanggal Lahir",
  "csv.fieldDorsal": "Nomor Punggung",
  "csv.fieldEmail": "Alamat Email",
  "csv.fieldOptional": "Opcional",
  "csv.fieldPlayerName": "Pemain Name",
  "csv.fieldPosition": "Posisi Utama",
  "csv.fieldRequired": "Requerido",
  "csv.importErrorToast": "Sebuah kesalahan occurred while importing pemain.",
  "csv.importSuccessToast": "{count} pemain imported successfully.",
  "csv.mappingIntro": "Map columns dari your spreadsheet ke Mister11 fields:",
  "csv.modalTitle": "Impor Pemain via CSV / Excel",
  "csv.selectColumn": "Pilih column...",
  "csv.status": "Estado",
  "csv.stepMapping": "Mapeo",
  "csv.stepPreview": "Vista Previa",
  "csv.stepUpload": "Subir",
  "csv.summaryErrors": "Rows dengan errors ke fix:",
  "csv.summaryReady": "Pemain ready for import:",
  "csv.tagValid": "Valid",
  "csv.templateSubtitle": "Unduh our official CSV template with predefined headers.",
  "csv.templateTitle": "Need sebuah template?",
  "dashboard.activity": "Berikut adalah aktivitas tim Anda ({club}) untuk minggu ini.",
  "dashboard.devAccess": "Akses Pengembang - Mister11 PRO",
  "dashboard.devDesc": "Your akun has lifetime access dengan all limits removed.",
  "dashboard.devUnlimited": "✔ PENGEMBANG TANPA BATAS",
  "dashboard.estimatedWorkload": "Perkiraan Beban Kerja",
  "dashboard.joinAsStaff": "Bergabung sebagai Staf Tim",
  "dashboard.noUpcomingSessions": "No upcoming sesi.",
  "dashboard.period.macro": "Makrosiklus ini",
  "dashboard.period.meso": "Mesosiklus ini",
  "dashboard.period.micro": "Mikrosiklus ini",
  "dashboard.period.session": "Sesi ini",
  "dashboard.period.week": "Minggu ini",
  "dashboard.quickAccess": "Akses Cepat",
  "dashboard.saveDashboard": "SIMPAN DASBOR",
  "dashboard.stats.matches": "Pertandingan",
  "dashboard.stats.noRival": "Tanpa lawan",
  "dashboard.stats.players": "Pemain",
  "dashboard.stats.rival": "Lawan Berikutnya",
  "dashboard.stats.sessions": "Sesi Latihan",
  "dashboard.teamWorkloadIndex": "Tim Workload Index",
  "dashboard.today": "Hari ini",
  "dashboard.upcomingSessions": "Upcoming Sesi Latihan",
  "dashboard.upgrade.activatePro": "Activar Modo PRO",
  "dashboard.upgrade.activateProTrial": "Activar Prueba PRO",
  "dashboard.upgrade.freePlanDesc": "Active limits: 1 tim, 23 pemain, 10 sesi dan 5 AI generations per month.",
  "dashboard.upgrade.freePlanTitle": "⭐ Mister11 Free Paket (Limited)",
  "dashboard.upgrade.planActiveDesc": "You have full access ke all features. Thank you untuk being part of Mister11 PRO.",
  "dashboard.upgrade.planActiveTitle": "👑 Mister11 {Paket} · Aktif Paket",
  "dashboard.upgrade.renewAccess": "🔓 PERBARUI AKSES",
  "dashboard.upgrade.resetTrial": "Reiniciar",
  "dashboard.upgrade.subscribe": "⚡ BERLANGGANAN",
  "dashboard.upgrade.trialActiveDesc": "You have full access ke all premium features. You have {days} days ({hours}h) of trial remaining.",
  "dashboard.upgrade.trialActiveTitle": "👑 Mister11 {Paket} · Free Trial Aktif",
  "dashboard.upgrade.trialExpiredDesc": "🔒 Your free trial has ended. Subscribe ke restore PRO access.",
  "dashboard.upgrade.trialExpiringDesc": "Only {hours} left of your trial. Subscribe ke maintain access.",
  "dashboard.upgrade.trialExpiringTitle": "⚠️ Masa uji coba Anda segera berakhir!",
  "dashboard.upgrade.tryFree": "Coba Gratis",
  "dashboard.upgrade.viewPlans": "Lihat Paket PRO",
  "dashboard.upgrade.viewPlansPro": "👑 VIEW PRO PaketS",
  "dashboard.viewAll": "Lihat semua",
  "dashboard.weeklyReport.desc": "Summary of trainings dan pertandingan ini week ({sesi} sesi, {pertandingan} pertandingan).",
  "dashboard.weeklyReport.download": "Unduh PDF",
  "dashboard.weeklyReport.ready": "Laporan Mingguan Anda sudah siap!",
  "dashboard.welcome": "Halo, {name}",
  "dashboard.workload.week": "Mgg",
  "day.Dom": "Min",
  "day.Jue": "Kam",
  "day.Lun": "Sen",
  "day.Mar": "Sel",
  "day.Mié": "Rab",
  "day.Sáb": "Sab",
  "day.Vie": "Jum",
  "download.cache_hint": "Tersimpan di cache. Jika tidak terbuka, cari \"{filename}\" di File",
  "download.csv_success": "✅ Template EkspoMerah Berhasilfully.",
  "download.generic_error": "Gagal mengekspor susunan pemain",
  "download.image_success": "✅ Image EkspoMerah Berhasilfully.",
  "download.json_success": "✅ File EkspoMerah Berhasilfully.",
  "download.lineup_downloading": "⬇️ Mengunduh susunan: {filename}",
  "download.lineup_saved": "✅ Lineup disimpan ke {path}",
  "download.lineup_share_dialog": "Simpan or share lineup...",
  "download.lineup_share_title": "Mister11 — Susunan {team}",
  "download.pdf_error": "Kesalahan saving PDF",
  "download.pdf_ready": "✅ PDF listo: \"{filename}\"",
  "download.save_error_share_fallback": "⚠️ Could not simpan file automatically; please use Share.",
  "download.saved_in": "✅ Tersimpan di: {path}",
  "download.video_success": "✅ Animasi berhasil diekspor.",
  "equipo.loadingSquad": "Memuat squad...",
  "equipo.publishAnnouncement": "Publikasikan Pengumuman",
  "equipo.tab.attendance": "Kehadiran",
  "equipo.tab.squad": "Skuad",
  "equipo.tab.staff": "Staf Pelatih",
  "equipo.title": "Manajemen Tim",
  "error.retry_section": "Reintentar",
  "error.section_code": "Kode: {code}",
  "error.section_desc": "Sebuah isolated anomaly occurred while rendering ini section.  rest of  pertandingan remains operational.",
  "error.section_unavailable": "Bagian tidak tersedia sementara",
  "errors.codeAlreadyUsed": "Kode ini sudah digunakan.",
  "errors.codeExpired": "Undangan ini telah kedaluwarsa.",
  "errors.codeInvalid": "Kode tidak valid. Harus memiliki 6 karakter.",
  "errors.codeNotFound": "Tim not found. Verify the code or contact the coach.",
  "exerciseCatalog.categories.cooldown": "Pendinginan",
  "exerciseCatalog.categories.main": "Menu Utama",
  "exerciseCatalog.categories.warmup": "Pemanasan",
  "exerciseCatalog.clinicalFallbackNotice": "Sumber resmi dalam verifikasi",
  "exerciseCatalog.phases.fase1": "Fase 1: Lari & Pemanasan Dinamis",
  "exerciseCatalog.phases.fase2": "Fase 2: Kekuatan, Pliometrik & Keseimbangan",
  "exerciseCatalog.phases.fase3": "Fase 3: Lari Cepat & Gerakan Memotong",
  "exerciseCatalog.sourceLabel": "Sumber",
  "exports.gk.claims": "Tangkap / Tinju Bola",
  "exports.gk.cleanSheets": "Clean Sheet",
  "exports.gk.conceded": "Kebobolan",
  "exports.gk.errors": "Kesalahan",
  "exports.gk.goalkeeper": "Kiper",
  "exports.gk.penaltySaves": "Penalti Diselamatkan",
  "exports.gk.rating": "Nilai Kiper",
  "exports.gk.savePct": "% Efisiensi",
  "exports.gk.saves": "Penyelamatan",
  "exports.gk.title": "KINERJA PENJAGA GAWANG",
  "exports.report.match_info": "Lembar Pertandingan",
  "exports.report.page": "Halaman",
  "exports.report.sec10_players": "10. Kinerja Individu Pemain & Skuad",
  "exports.report.sec11_swot": "11. Analisis SWOT Taktis & Rekomendasi",
  "exports.report.sec1_lineup": "1. Susunan Taktis dengan Foto",
  "exports.report.sec2_timeline": "2. Papan Skor & Kronologi Pertandingan",
  "exports.report.sec3_momentum": "3. Momentum & Penguasaan Bola per Blok 15 Menit",
  "exports.report.sec4_bars": "4. Batang Komparatif (10 Metrik)",
  "exports.report.sec5_radar": "5. Radar Komparatif (Tim Sendiri vs Lawan)",
  "exports.report.sec6_top5": "6. 5 Metrik Pembeda Teratas",
  "exports.report.sec7_shots": "7. Peta Tembakan & Model xG-Lite",
  "exports.report.sec8_tactics": "8. Lapangan & Taktik (Koridor, Bola Mati & Teritori)",
  "exports.report.sec9_gk": "9. Beban Kerja & Kinerja Penjaga Gawang",
  "exports.report.sec_photos": "Foto & Bukti Pertandingan",
  "exports.report.tactical_analysis": "Analisis Taktis",
  "exports.report.title": "LAPORAN RESMI PASCA PERTANDINGAN",
  "exports.test.attendance": "Kehadiran",
  "exports.test.mental": "Tes Mental / Psikososial",
  "exports.test.physical": "Tes Fisik",
  "exports.test.radar_title": "Profil Kinerja Komprehensif",
  "exports.test.recommendation_title": "Rekomendasi Individu",
  "exports.test.table_interp": "Interpretasi",
  "exports.test.table_score": "Skor",
  "exports.test.table_test": "Tes",
  "exports.test.tactical": "Tes Taktis",
  "exports.test.technical": "Tes Teknis",
  "exports.test.title": "LAPORAN EVALUASI & TES",
  "form.teamName": "Tim Name",
  "games.assignment.todayPrompt": "Coaching staff has assigned you sebuah special challenge",
  "games.badge.recommended": "Recommended oleh your pelatih",
  "games.best.accuracy": "Accuracy: {val}%",
  "games.best.hits": "Aciertos: {val}/5",
  "games.best.maxCones": "Max: {val} cones",
  "games.best.record": "Record: {val} ms",
  "games.btn.backToCatalog": "Kembali to Catalog",
  "games.btn.play": "Jugar",
  "games.btn.practiceFirst": "Try di Practice Mode",
  "games.btn.startOfficial": "Start Sesi Latihan",
  "games.btn.startReto": "Entrenar",
  "games.disclaimer": "Support cognitive latihan, not therapy; follow specialist advice untuk ADHD.",
  "games.finish.healthyClosing": "Great mental work! Rest your eyes dan body.",
  "games.finish.subtitle": "You have selesai  sesi dengan dedication.",
  "games.finish.title": "Outstanding effort!",
  "games.g1.falseStart": "🚫 False start.",
  "games.g1.skill": "Reaction Speed",
  "games.g1.statBest": "Mejor marca",
  "games.g1.statFalses": "Salidas falso",
  "games.g1.statMedian": "Rata-ratana",
  "games.g1.step1": "Wait on red.",
  "games.g1.step2": "Tap  screen when it turns GREEN.",
  "games.g1.step3": "Ketukping earlier = Salah start.",
  "games.g1.tapAreaPrompt": "Ketuk here when it turns GREEN",
  "games.g1.tapNow": "TAP NOW!",
  "games.g1.title": "Pro Traffic Light",
  "games.g1.tooSlow": "Too slow! Miss.",
  "games.g1.waitGreen": "Wait for green…",
  "games.g1.what": "React di milliseconds: reach  ball before your opponent.",
  "games.g1.why": "Arriving 0.2s earlier ke sebuah loose ball changes  play. Reaction can be trained dan transfers ke runs dan interceptions.",
  "games.g2.crMsg": "🛑 Perfect brake!",
  "games.g2.faMsg": "🚫 It was red: you had ke brake.",
  "games.g2.missMsg": "⏱️ Green slipped away.",
  "games.g2.prepare": "Watch the cone…",
  "games.g2.skill": "Self-control & Keputusan",
  "games.g2.statAcc": "Accuracy",
  "games.g2.statFa": "Frenadas fallidas",
  "games.g2.statRt": "Tiempo medio",
  "games.g2.step1": "Sebuah cone appears di one of  squares.",
  "games.g2.step2": "GREEN → Ketuk it quickly.",
  "games.g2.step3": "Merah → do TidakT Ketuk, brake your finger.",
  "games.g2.title": "Freno Impulsivo",
  "games.g2.what": "Hold Kembali impulses: decide before taking action.",
  "games.g2.why": "Most mistakes come dari acting hastily.  \"brake\" improves dribbling, prevents fouls dan helps pemain dengan ADHD.",
  "games.g3.hitMsg": "✅ Buka Timmate found!",
  "games.g3.markedMsg": "❌ That one was marked. Look untuk  open one.",
  "games.g3.practiceGuide": "open teammate shines di gold. Tap them!",
  "games.g3.rivalMsg": "😉 That is sebuah opponent. Look untuk your teammate.",
  "games.g3.scanPrompt": "Scan dengan your eyes…",
  "games.g3.skill": "Visual Scanning & Perception",
  "games.g3.statHits": "Aciertos",
  "games.g3.statRounds": "Rondas",
  "games.g3.statTime": "Tiempo medio",
  "games.g3.step1": "🟢 Timmates · 🔴 opponents.",
  "games.g3.step2": "Tap  teammate dengan  MOST open space.",
  "games.g3.step3": "5 detik per round.",
  "games.g3.timeOut": "⏱️ Time up.  open pemain was  clearest.",
  "games.g3.title": "Tactical Eye",
  "games.g3.what": "See  pitch: find  open teammate before receiving.",
  "games.g3.why": "Pros scan 6-8 times every 10 s. Spotting  open pemain before receiving turns sebuah good decision into sebuah great pass.",
  "games.g4.correctMsg": "✅ Perfect sequence!",
  "games.g4.missMsg": "❌ Tutup. Keep trying.",
  "games.g4.repeat": "Repeat  sequence!",
  "games.g4.skill": "Working Memory",
  "games.g4.statMax": "Max sequence",
  "games.g4.statOk": "Rondas acertadas",
  "games.g4.statRange": "Rango",
  "games.g4.step1": "Watch  order di which  cones light up.",
  "games.g4.step2": "Repeat  sequence oleh tapping  same cones.",
  "games.g4.step3": "Each round  sequence gets longer.",
  "games.g4.title": "Cone Memory",
  "games.g4.watch": "Watch closely…",
  "games.g4.what": "Remember Informasi under Tekanure.",
  "games.g4.why": "Remembering cues dan patterns sharpens attention dan tactical comprehension:  pemain's \"mental board\".",
  "games.g5.cycleHeader": "Cycle {current} of {Total}",
  "games.g5.exhale": "Exhala",
  "games.g5.exhaleTip": "Release  breath gently through your mouth",
  "games.g5.inhale": "Inhala",
  "games.g5.inhaleTip": "Inhale sRendahly through your Tidakse filling your abdomen",
  "games.g5.skill": "Calma y autocontrol",
  "games.g5.statBenefit": "Beneficio",
  "games.g5.statCycles": "Ciclos",
  "games.g5.statTempo": "Tempo",
  "games.g5.step1": "Circle expands → inhale gently through your Tidakse (4 s).",
  "games.g5.step2": "Circle shrinks → exhale sRendahly through your mouth (4 s).",
  "games.g5.step3": "6 complete cycles, no rush atau scoring.",
  "games.g5.title": "4-4 Breathing",
  "games.g5.what": "Calm nerves before playing.",
  "games.g5.why": "4-4 box breathing activates  parasympathetic system: lowers heart rate dan anxiety di ~1 min. Used oleh elite athletes; it's simple dan done anywhere. That's why we chose it.",
  "games.g5.zenBadge": "6 calm cycles",
  "games.g6.clueGoal": "Goal:",
  "games.g6.clueMate": "Teammate:",
  "games.g6.clueSpace": "Espacio libre:",
  "games.g6.optDribble": "DRIBBLE",
  "games.g6.optPass": "PASS",
  "games.g6.optShoot": "SHOT",
  "games.g6.prompt": "Decide fast!",
  "games.g6.skill": "Taktis Reading",
  "games.g6.statAcc": "Aciertos",
  "games.g6.statPct": "Accuracy",
  "games.g6.statTime": "Tiempo medio",
  "games.g6.step1": "Read  3 clues pada screen.",
  "games.g6.step2": "Gol Buka → Tembakan.",
  "games.g6.step3": "Otherwise, Timmate Buka → Operan. Else → DRIBBLE (4 s limit).",
  "games.g6.timeOutMsg": "⏱️ Time up.  best choice was {option}.",
  "games.g6.title": "1-Detik Keputusan",
  "games.g6.what": "Pick  best action di sebuah glance: pass, shot atau dribble.",
  "games.g6.why": "Football is played dengan  head: deciding fast dan well sets great pemain apart.",
  "games.honesty.pact": "Honesty pact: record your real repetitions.  effort is yours!",
  "games.intro.howTitle": "How to Play",
  "games.intro.whatTitle": "What We Train",
  "games.intro.whyTitle": "Why It Helps pada  Pitch",
  "games.legend_ceiling": "👑 You reached  Legend ceiling! You are sebuah legend!",
  "games.level_up": "🎉 You leveled up ke {level}! {badge} (+10 XP)",
  "games.limits.available": "Disponible",
  "games.limits.cognitiveLbl": "Juegos Cognitivos",
  "games.limits.cognitiveLockedDesc": "You have reached  healthy limit of 15 menit of cognitive games. Rest your mind ke consolidate what you learned!",
  "games.limits.cognitiveLockedTitle": "🧠 Mind trained untuk today!",
  "games.limits.completed": "Completado",
  "games.limits.completedToday": "Completed untuk today",
  "games.limits.lockedDesc": "You have reached  healthy daily latihan limit. Come back tomorrow ke keep improving.",
  "games.limits.lockedTitle": "Well done untuk today!",
  "games.limits.minutesLbl": "Tiempo jugado",
  "games.limits.remainingMin": "Te quedan {count} min hoy",
  "games.limits.remainingTime": "{waktu} remaining today",
  "games.limits.retosLbl": "Home Challenges",
  "games.limits.retosLockedDesc": "You have reached your 20 menit of home challenges untuk today. Great physical effort, recover untuk  next practice!",
  "games.limits.retosLockedTitle": "⚽ Body dan technique trained!",
  "games.limits.sessionsLbl": "Sesi Latihan today",
  "games.limits.title": "Healthy Pelatihan",
  "games.ranking.empty": "Start your latihan ke open  week's podium.",
  "games.ranking.resetInfo": "Reset cada lunes",
  "games.ranking.subtitle": "Sebuah healthy growth space rewarding consistency dan personal improvement, not cut-throat rivalry.",
  "games.ranking.tabImproved": "Most Improved",
  "games.ranking.tabPoints": "Puntos Semanales",
  "games.ranking.title": "Ranking Semanal Saludable",
  "games.retos.addRep": "+1 Repetition",
  "games.retos.attemptsExhausted": "Limit of 2 attempts reached untuk today. Rest dan come back tomorrow!",
  "games.retos.attemptsToday": "intentos hoy",
  "games.retos.btnStart": "Iniciar Reto",
  "games.retos.btnSuperado": "Completado hoy",
  "games.retos.completedBadge": "Superado hoy",
  "games.retos.completedResult": "Completado",
  "games.retos.crp.metric": "Mejor racha",
  "games.retos.crp.skill": "Koordinasi",
  "games.retos.crp.title": "Cabeza-Rodilla-Pie",
  "games.retos.crp.what": "Head-knee-foot control sequence.",
  "games.retos.cuerda.metric": "Saltos totales",
  "games.retos.cuerda.skill": "Footwork agility dan stamina",
  "games.retos.cuerda.title": "Jump Rope",
  "games.retos.cuerda.what": "Foot speed agility dan stamina.",
  "games.retos.dom.metric": "Mejor racha",
  "games.retos.dom.skill": "Touch dan control",
  "games.retos.dom.title": "Ball Juggling",
  "games.retos.dom.what": "Ball touch dan control.",
  "games.retos.eq.metric": "Sets superados",
  "games.retos.eq.skill": "Proprioception",
  "games.retos.eq.title": "Tantangan Keseimbangan",
  "games.retos.eq.what": "Ankle balance dan stability.",
  "games.retos.esc.metric": "Sets superados",
  "games.retos.esc.skill": "Foot quickness",
  "games.retos.esc.title": "Agility Ladder",
  "games.retos.esc.what": "Quick footwork dan motor speed.",
  "games.retos.finishSet": "Terminar Set ✔",
  "games.retos.lockedBtn": "Locked untuk today",
  "games.retos.pared.metric": "Pases totales",
  "games.retos.pared.skill": "Passing dan weak foot",
  "games.retos.pared.title": "Wall Passes",
  "games.retos.pared.what": "Accurate passing dan non-dominant foot.",
  "games.retos.punt.metric": "Aciertos totales",
  "games.retos.punt.skill": "Operaning accuracy",
  "games.retos.punt.title": "Cone Target",
  "games.retos.punt.what": "Long-Jarak Operaning accuracy.",
  "games.retos.questionTimer": "Did you keep up  exercise untuk  whole duration?",
  "games.retos.recommendedBadge": "Asignado",
  "games.retos.reg.metric": "Sets superados",
  "games.retos.reg.skill": "Ball handling",
  "games.retos.reg.title": "Dribbling Slalom",
  "games.retos.reg.what": "Dribbling through cones dengan pace change.",
  "games.retos.repetitions": "{count} repeticiones",
  "games.retos.setHeader": "Set {current} of {Total}",
  "games.retos.setsWord": "sets",
  "games.retos.startTimer": "Comenzar Tiempo",
  "games.retos.statSets": "Sets",
  "games.retos.statStatus": "Resultado",
  "games.retos.streakEnd": "Bola jatuh / Akhir rentetan",
  "games.retos.timeExhausted": "You have reached  20-minute daily challenge limit. Great physical effort!",
  "games.retos.touchesStreak": "{count} touches di sebuah row",
  "games.safety.title": "Safety at Home",
  "games.status.notPlayed": "Sin registro",
  "games.status.practice": "Practice (unSkord)",
  "games.tabs.cognitive": "Kognitif Games (6)",
  "games.tabs.retos": "Tantangan Rumah (8)",
  "games.timer.paused": "Pausado",
  "games.timer.remainingChip": "Remaining today: {waktu}",
  "games.timer.setFinishing": "Final set",
  "gk.activeGoalkeeper": "GolKiper ON Lapangan",
  "gk.aerialClaim": "Duel Udara Kiper",
  "gk.boxDominance": "Penguasaan Kotak Penalti",
  "gk.btn.claim": "Salida / Rechace",
  "gk.btn.conceded": "Gol Encajado",
  "gk.btn.errorGoal": "Error Leading ke Goal",
  "gk.btn.penaltySave": "Penalti Parado",
  "gk.btn.save": "Simpan",
  "gk.buildup": "Distribusi Bola",
  "gk.claims": "Salidas y Despejes",
  "gk.claimsShort": "Salidas",
  "gk.cleanSheets": "Clean Sheets",
  "gk.cleanSheetsShort": "Invicto",
  "gk.conceded": "Goals Conceded",
  "gk.concededShort": "Enc.",
  "gk.diveLow": "Tangkapan Bawah",
  "gk.errorGoal": "Errors Leading ke Goal",
  "gk.errorGoalShort": "Err. Gol",
  "gk.events.empty": "No goalkeeping events recorded untuk ini pertandingan.",
  "gk.events.list": "Golkeeping Events",
  "gk.evolution": "Simpan % Evolution",
  "gk.history": "Pertandingan History",
  "gk.noActiveGoalkeeper": "No aktif goalkeeper pada pitch",
  "gk.parrySafe": "Tepis Aman",
  "gk.penaltySaves": "Penaltis Parados",
  "gk.penaltySavesShort": "Pen. Par.",
  "gk.perMatch": "Por pertandingan",
  "gk.rating": "GK Rating",
  "gk.reflexClose": "Refleks Jarak Dekat",
  "gk.role": "Kiper",
  "gk.roleBadge": "🧤 Portero",
  "gk.saveHigh": "Penyelamatan Atas",
  "gk.savePercentage": "Simpan %",
  "gk.savePercentageShort": "Simpan %",
  "gk.saves": "Paradas",
  "gk.savesShort": "Par.",
  "gk.smother": "Blok Dekat",
  "gk.suggest.confirm": "Yes, assign ke goalkeeper",
  "gk.suggest.ignore": "Tidak, record Gol only",
  "gk.suggest.message": "Sebuah opponent goal was recorded. Do you want ke tambah 1 conceded goal ke  aktif goalkeeper ({nama})?",
  "gk.suggest.title": "Assign conceded Gol?",
  "gk.sweeper": "Kiper Penyapu",
  "gk.title": "Metrik Khusus Penjaga Gawang",
  "gk.tooltip.claim": "Aerial claim, interception, atau punched clearance.",
  "gk.tooltip.cleanSheet": "Match selesai dengan menit played tanpa conceding sebuah goal.",
  "gk.tooltip.conceded": "Goal allowed while playing di goal.",
  "gk.tooltip.errorGoal": "Direct mistake di possession atau positioning resulting di sebuah opponent goal.",
  "gk.tooltip.penaltySave": "Penalty kick disimpan during  pertandingan.",
  "gk.tooltip.save": "Successful intervention preventing sebuah opponent goal.",
  "header.logoutConfirm": "Do you want ke log out atau switch accounts?",
  "header.switchPlayerPortal": "Switch to Pemain Portal",
  "health.active": "Activo",
  "health.addInjury": "+ Record Injury",
  "health.additionalNotes": "Catatan Tambahan",
  "health.affectedArea": "Area Terdampak *",
  "health.cancel": "Batal",
  "health.injuryDate": "Tanggal Cedera *",
  "health.injuryType": "Jenis Cedera *",
  "health.markRecovered": "Tandai sebagai Pulih",
  "health.medicalNotes": "Catatan Medis",
  "health.medicalNotesPlaceholder": "Alergi, perawatan berkelanjutan, catatan medis...",
  "health.noInjuries": "Tidak injuries recorded.",
  "health.recordInjury": "Catat Cedera Baru",
  "health.resolved": "Recuperado",
  "health.saveInjury": "Simpan Injury",
  "health.status.active": "Tersedia / Aktif",
  "health.status.current": "Status Saat Ini",
  "health.status.injured": "Cedera",
  "health.status.recovery": "Dalam Pemulihan",
  "health.status.rest": "Istirahat",
  "health.title": "Medical History & Injuries",
  "health.updateStatus": "Perbarui Status Umum",
  "ia.additionalObs": "Tambahitional observations",
  "ia.age.alevin": "Under-12 (10-12)",
  "ia.age.amateur": "Amateur",
  "ia.age.base": "Grassroots (6-10 years)",
  "ia.age.cadete": "Cadete (14-16)",
  "ia.age.infantil": "Infantil (12-14)",
  "ia.age.juvenil": "Juvenil (16-18)",
  "ia.age.prebenjamin": "Under-10 (8-10)",
  "ia.animation": "Animation ({count}F)",
  "ia.btnClear": "🔄 Limpiar",
  "ia.btnExportPdf": "📄 Ekspor PDF",
  "ia.btnGeneratePrevention": "🩺 Generate Latihan Plan",
  "ia.btnGenerateTactical": "✨ Generate Latihan",
  "ia.btnSave": "💾 Simpan",
  "ia.capture": "Captura",
  "ia.categoryAge": "KATEGORI / USIA",
  "ia.defaultTitle": "AI Latihan {time}",
  "ia.dictationNotSupported": "Your browser does not dukungan voice dictation. Use Chrome pada Android untuk ini feature.",
  "ia.dictationStart": "Voice dictation",
  "ia.dictationStop": "Detener dictado",
  "ia.drawerTitle": "☁️ Biblioteca Cloud",
  "ia.durationMinutes": "{count} mnt",
  "ia.emptyLibrary": "No disimpan exercises yet.",
  "ia.emptyPlaceholder": "Latihan Anda akan muncul di sini",
  "ia.emptyResponse": "Empty response dari AI",
  "ia.intensityLabel": "Intensitas",
  "ia.level.advanced": "Avanzado",
  "ia.level.basic": "Basic",
  "ia.level.intermediate": "Intermedio",
  "ia.libraryBtn": "☁️ Pustaka ({count})",
  "ia.limitReached": "You have reached  monthly limit of {limit} AI generations.  limit resets next month.",
  "ia.listening": "🔴 Listening... speak Tidakw",
  "ia.loadingAnalyzing": "⏳ Analizando contexto...",
  "ia.loadingGenerating": "Generando...",
  "ia.loadingUsage": "🔑 AI: Memuat usage...",
  "ia.mainObjective": "TUJUAN UTAMA",
  "ia.mat.balls": "Bola",
  "ia.mat.bibs": "Rompi",
  "ia.mat.cones": "Kerucut",
  "ia.mat.goals": "Gawang",
  "ia.mat.hurdles": "Rintangan",
  "ia.mat.ladder": "Tangga ketangkasan",
  "ia.mat.none": "Tidak specific equipment",
  "ia.mat.rings": "Aros",
  "ia.materials": "PERALATAN",
  "ia.modalDetail": "Detalle",
  "ia.modalLoad": "Cargar",
  "ia.modalNoContent": "Sin contenido.",
  "ia.modalOpenBoard": "Open in Board",
  "ia.modePrevention": "Pencegahan /\nPemulihan",
  "ia.modeTactical": "Latihan\nTaktis",
  "ia.noRef": "Sin Ref.",
  "ia.numPlayers": "JML PEMAIN: {count}",
  "ia.obj.aerobic": "Aerobic Daya Tahan",
  "ia.obj.agility": "Kelincahan & Koordinasi",
  "ia.obj.cooldown": "Pendinginan",
  "ia.obj.crossing": "Umpan Silanging & box arrivals",
  "ia.obj.finishing": "Finishing & shooting",
  "ia.obj.positional": "Positional play",
  "ia.obj.possession": "Posesi de balón",
  "ia.obj.pressing": "Tekaning & Serangan Balik-Tekan",
  "ia.obj.speed": "Kecepatan",
  "ia.obj.strength": "Kekuatan & Daya",
  "ia.obj.transAttDef": "Transition attack-ke-defense",
  "ia.obj.transDefAtt": "Transition defense-ke-attack",
  "ia.obj.warmup": "Pemanasan",
  "ia.obsPlaceholder": "E.g. Focus pada execution speed atau defensive transition...",
  "ia.phaseLabel": "Fase permainan",
  "ia.prev.availableMaterial": "Tersedia Equipment",
  "ia.prev.bodyZone": "Zona Corporal",
  "ia.prev.descLabel": "Clinical Description / Problem",
  "ia.prev.descPlaceholder": "E.g.: 16yo pemain dengan left hamstring overload post-pertandingan, requires eccentric dan strengthening exercises...",
  "ia.prev.noMaterial": "Sin material",
  "ia.prev.planType": "Plan Type",
  "ia.prev.playerLevel": "Pemain Level",
  "ia.prev.typePrevention": "Prevention",
  "ia.prev.typeReadaptation": "Readaptation",
  "ia.prev.typeRecovery": "Recovery",
  "ia.recoveryNotice": "Sesi difokuskan pada pemulihan otot dan pencegahan.",
  "ia.saveError": "Kesalahan saving Latihan. Please try again.",
  "ia.saveSuccess": "✅ Saved ke library: \"{title}\"",
  "ia.selectPlaceholder": "Pilih...",
  "ia.space": "Espacio",
  "ia.space.box": "Penalty area",
  "ia.space.full": "Campo completo",
  "ia.space.gym": "Sala / Gimnasio",
  "ia.space.half": "Medio campo",
  "ia.space.small": "Area ruang kecil",
  "ia.space.threeQuarter": "3/4 campo",
  "ia.subtitle": "DESAIN SESI LATIHAN CERDAS",
  "ia.tacticalBoard": "🎬 Pizarra",
  "ia.tacticalRef": "Taktis Reference (Opsial)",
  "ia.title": "Asisten Taktis AI",
  "ia.usageRemaining": "🔑 AI: you have {count} uses left ini month (limit {limit})",
  "ia.validationPrevention": "Please describe  case dan pilih sebuah body zone.",
  "ia.validationTactical": "Please fill di: Age, Objective, dan Pitch Area.",
  "ia.zone.adductors": "Aductores",
  "ia.zone.ankle": "Tobillo",
  "ia.zone.calves": "Gemelos",
  "ia.zone.core": "Core / Pelvis",
  "ia.zone.hamstring": "Isquiotibial",
  "ia.zone.knee": "Rodilla",
  "ia.zone.lumbar": "Lumbar",
  "ia.zone.quadriceps": "Quadriceps",
  "ia.zone.shoulder": "Hombro",
  "install.alreadyInstalled": "App is already installed pada your device!",
  "install.androidDesc": "Tap  \"Install now\" button below atau open  three dots menu (⋮) dan pilih \"Install app\".",
  "install.androidTitle": "Android (Browser Chrome):",
  "install.btnInstall": "Instalar ahora",
  "install.fallbackNotice": "If you do not see  install button, use  \"Add ke Home Screen\" option di your browser.",
  "install.instructions": "Instrucciones:",
  "install.iosDesc": "Tap  \"Share\" button (square dengan arrow) dan pilih \"Add ke Home Screen\".",
  "install.iosTitle": "iOS (Safari):",
  "install.metaDesc": "Step-oleh-step installation instructions untuk Mister11 PWA pada Android dan iOS devices.",
  "install.metaTitle": "Install Mister11 —  Football App untuk Coaches",
  "install.slogan": "bench di your pocket",
  "install.title": "Instal Aplikasi Mister11",
  "invite.already_registered": "This email is already registered atau invited ke  club.",
  "invite.coach.codePlaceholder": "Invitation code (6 characters)",
  "invite.coach.scanQR": "Scan invitation QR",
  "invite.coach.title": "Gabung sebagai Pelatih / Staf",
  "invite.generated_error": "Error generating  invitation.",
  "invite.generated_success": "Invitation generated Berhasilfully.",
  "invite.link_copied": "Link copied!",
  "invite.player.codePlaceholder": "Tim code",
  "invite.player.scanQR": "Escanear QR del tim",
  "invite.player.title": "Join Your Tim",
  "joinTeam.account_created": "Account created Berhasilfully",
  "joinTeam.already_member": "You are already pada ini tim! Loading your portal...",
  "joinTeam.google_sign_in": "Signed di dengan Google",
  "joinTeam.request_approved": "Your request has been approved!",
  "joinTeam.request_sent": "Request sent ke  pelatih!",
  "joinTeam.welcome": "Welcome ke Mister11",
  "live.action.foul": "Pelanggaran",
  "live.action.goal": "Gol",
  "live.action.offside": "Offside",
  "live.action.recovery": "Perebutan Bola",
  "live.action.redCard": "Kartu Merah",
  "live.action.shot": "Tembakan",
  "live.action.turnover": "Kehilangan Bola",
  "live.action.yellowCard": "Kartu Kuning",
  "live.btn.card_red_own": "Roja (Propia)",
  "live.btn.card_red_rival": "Merah Kartu (Opponent)",
  "live.btn.card_yellow_own": "YelRendah Kartu (Own)",
  "live.btn.card_yellow_rival": "YelRendah Kartu (Opponent)",
  "live.btn.corner_against": "Corner Against",
  "live.btn.corner_favor": "Corner in Favor",
  "live.btn.counter_not_cut": "Contra No Cortada",
  "live.btn.duel_lost": "Duelo Perdido",
  "live.btn.duel_won": "Duelo Ganado",
  "live.btn.foul_against": "Foul Against",
  "live.btn.foul_favor": "Falta a Favor",
  "live.btn.loss": "Kehilangan Bola",
  "live.btn.offside_own": "Offside (Own)",
  "live.btn.offside_rival": "Offside (Opponent)",
  "live.btn.player_no_finish": "Jugada No Finalizada",
  "live.btn.recovery": "Rebut Bola",
  "live.btn.save_own": "Goalkeeper Simpan (Own)",
  "live.btn.save_rival": "Goalkeeper Simpan (Opponent)",
  "live.btn.shot_off_own": "Tembakan off Target (Own)",
  "live.btn.shot_off_rival": "Tembakan off Target (Opponent)",
  "live.btn.shot_on_own": "Shot pada Target (Own)",
  "live.btn.shot_on_rival": "Shot pada Target (Opponent)",
  "live.tab.analytics": "Advanced Analysis",
  "live.tab.capture": "Live Capture",
  "live.tab.players": "Pemain & CSV",
  "live.tab.tactical": "Field & Tactics",
  "liveStats.quickMode.advanced": "Advanced Opsis",
  "liveStats.quickMode.shotSaved": "Tiro registrado",
  "liveStats.quickMode.simple": "Modo simple",
  "liveStats.quickMode.title": "Quick Mode",
  "liveStats.quickMode.undo": "Deshacer",
  "liveStats.quickMode.undone": "Tiro deshecho",
  "livestats.match_locked_short": "⚠️ Match selesai",
  "livestats.match_locked_use_reopen": "⚠️ Match selesai — use Reopen Match Sheet ke correct.",
  "livestats.post_match_saved": "✅ Post-pertandingan counters disimpan",
  "livestats.select_player_first": "👆 Pilih pemain terlebih dahulu",
  "login.account_created": "Account created Berhasilfully!",
  "login.cancelled": "Sign-di cancelled oleh user",
  "login.recovery_error": "Kesalahan Kiriming email",
  "login.recovery_sent": "Recovery link sent ke your email",
  "login.welcome": "Welcome ke Mister11!",
  "login.write_email_first": "Escribe tu correo primero",
  "match.btn.exportIcs": "EKSPOR ICS",
  "match.btn.newMatch": "+ PERTANDINGAN BARU",
  "match.btn.pdfCalendar": "KALENDER PDF",
  "match.defaultMyTeam": "Tim Saya",
  "match.defaultRival": "Lawan",
  "match.filter.all": "Semua",
  "match.filter.finished": "Selesai",
  "match.filter.pending": "Tertunda",
  "match.formationLabel": "Formasi: ",
  "match.locked_reopen": "⚠️ Match selesai. Reopen pertandingan sheet ke record events.",
  "match.management.title": "MANAJEMEN PERTANDINGAN",
  "match.noVenue": "Tanpa lokasi",
  "match.sort.cercania": "Terdekat dari hari ini",
  "match.sort.estado": "Berdasarkan Status / Prioritas",
  "match.sort.fecha_asc": "Tanggal (Mendatang)",
  "match.sort.fecha_desc": "Tanggal (Terbaru)",
  "match.sort.label": "Urutkan berdasarkan",
  "match.sort.lejania": "Paling jauh dari hari ini",
  "match.status.en_edicion": "DALAM EDITING",
  "match.status.finalizado": "SELESAI",
  "match.status.no_disputado": "BELUM DIMAINKAN",
  "match.status.pendiente": "TERTUNDA",
  "match.venue.local": "Kandang",
  "match.venue.municipal": "Stadion Kota",
  "match.view.cards": "Kartu",
  "match.view.detailed": "Rinci",
  "matchSheet.anomalies_resolved": "✔ {count} anomaly(ies) resolved dan sheet synchronized.",
  "matchSheet.auto_badge": "Auto",
  "matchSheet.close_error": "❌ Error closing pertandingan sheet. Please try again.",
  "matchSheet.closed_success": "✅ Match sheet closed. Real menit disimpan.",
  "matchSheet.closed_with_warnings": "⚠️ Match sheet closed dengan recorded warnings.",
  "matchSheet.confirm_save_btn": "💾 Konfirmasi & Simpan SHEET",
  "matchSheet.confirm_save_tooltip": "Simpan all manual minute corrections and update the official match sheet",
  "matchSheet.log_already_clean": "✨  pertandingan log is already clean. Zero impossible events.",
  "matchSheet.log_debug_error": "❌ Kesalahan debugging log.",
  "matchSheet.manual_allowed_closed": "Diizinkan bahkan saat ditutup",
  "matchSheet.manual_badge": "Manual",
  "matchSheet.manual_override_title": "Manual menit override",
  "matchSheet.prefill_rsvp_empty": "No tertunda RSVP responses ke pre-fill.",
  "matchSheet.prefill_rsvp_error": "❌ Error pre-filling dari RSVP.",
  "matchSheet.prefill_rsvp_success": "✅ Statuses pre-filled dari RSVP.",
  "matchSheet.prefill_smart_error": "❌ Error di smart pre-filling.",
  "matchSheet.prefill_smart_success": "⚡ Match sheet smartly pre-filled dari lineup dan events.",
  "matchSheet.referee": "Wasit",
  "matchSheet.reopen_error": "❌ Error reopening pertandingan sheet.",
  "matchSheet.reopened_info": "🔓 Match sheet dan pertandingan reopened untuk corrections.",
  "matchSheet.saving": "💾 Guardando...",
  "matchSheet.signatures": "Tanda Tangan Resmi",
  "matchSheet.tactical_grade_saved": "⭐ Tactical rating disimpan",
  "matchSheet.weather": "Cuaca / Lapangan",
  "matches.finish_error": "❌ Kesalahan saving completion:",
  "matches.lineup.benchTitle": "CadanganS Bangku Cadangan",
  "matches.lineup.downloadPng": "DESCARGAR PNG",
  "matches.lineup.emptySlot": "Empty",
  "matches.lineup.exportingPng": "EXPORTANDO...",
  "matches.lineup.subtitle": "Tactical board dengan starting XI dan substitutes bench",
  "matches.lineup.title": "Taktis Lineup & Bangku Cadangan",
  "matches.log_cleanse_error": "❌ Kesalahan cleansing log.",
  "matches.log_cleansed": "🧹 Log cleansed Berhasilfully. {count} records sanitized.",
  "matches.repair_error": "❌ Error repairing pertandingan.",
  "matches.repaired": "✅ Match repaired dan persisted successfully.",
  "matches.warnings.auditHide": "Hide audit",
  "matches.warnings.auditNote": "Log cleansed pada {tanggal}: {count} anomalies isolated dan resolved.",
  "matches.warnings.auditShow": "Lihat detalle",
  "matches.warnings.bannerTitle": "This pertandingan contained {count} isolated log anomalies atau legacy data.",
  "matches.warnings.chipTooltip": "{count} anomalies detected di log (click ke view dan resolve di Official Sheet)",
  "matches.warnings.cleanseBtn": "Cleanse & Resolve",
  "matches.warnings.cleansing": "Depurando...",
  "matches.warnings.hideDetails": "Ocultar detalles",
  "matches.warnings.resolvedSuccess": "✔ {count} anomaly/anomalies resolved dan pertandingan sheet synchronized.",
  "matches.warnings.showDetails": "Lihat lista",
  "month.Abr": "Abr",
  "month.Ago": "Agt",
  "month.Dic": "Des",
  "month.Ene": "Jan",
  "month.Feb": "Feb",
  "month.Jul": "Jul",
  "month.Jun": "Jun",
  "month.Mar": "Mar",
  "month.May": "Mei",
  "month.Nov": "Nov",
  "month.Oct": "Okt",
  "month.Sep": "Sep",
  "nav.admin": "ADMINISTRASI",
  "nav.dashboard": "DASBOR",
  "nav.equipo": "TIM SAYA",
  "nav.ia": "IA GENERADORA",
  "nav.partidos": "PERTANDINGAN",
  "nav.pizarra": "PAPAN TAKTIK",
  "nav.planificacion": "PERENCANAAN",
  "nav.sesiones": "SESI LATIHAN",
  "nav.tests": "TES & EVALUASI",
  "notifPrefs.chatDesc": "Alerts untuk new messages di tim squad chat",
  "notifPrefs.chatTitle": "Tim Messages",
  "notifPrefs.errorToast": "Kesalahan saving Tidaktification preferences",
  "notifPrefs.frequencyCapDesc": "Maximum number of notifikasi per day",
  "notifPrefs.frequencyCapTitle": "Frequency Cap",
  "notifPrefs.matchDesc": "Alerts untuk call-up rosters, schedules dan upcoming pertandingan",
  "notifPrefs.matchTitle": "Pertandingan & Pemanggilan",
  "notifPrefs.perDay": "per day",
  "notifPrefs.quietHoursDesc": "Do not receive push notifikasi during ini waktu window",
  "notifPrefs.quietHoursEnd": "Quiet end time",
  "notifPrefs.quietHoursStart": "Quiet start waktu",
  "notifPrefs.quietHoursTitle": "Quiet Hours",
  "notifPrefs.reminderTime": "Waktu pengingat",
  "notifPrefs.savedToast": "Notification preferences disimpan successfully",
  "notifPrefs.title": "Preferensi Notifikasi",
  "notifPrefs.wellnessDesc": "Daily reminder ke fill out your health form",
  "notifPrefs.wellnessTitle": "Wellness Check-di",
  "notifications.empty": "Anda tidak memiliki notifikasi tertunda.",
  "notifications.individualPlanAssigned": "Rencana individual berhasil ditetapkan",
  "notifications.individualPlanRemoved": "Rencana individual dihapus",
  "notifications.newExerciseSaved": "Latihan baru disimpan: {name}",
  "notifications.newMatchRegistered": "Pertandingan baru dicatat vs {opponent}",
  "notifications.newPlayerAdded": "Pemain baru ditambahkan: {name}",
  "notifications.newSessionCreated": "Sesi baru dibuat: {title}",
  "notifications.predefinedExerciseError": "Anda tidak dapat menghapus latihan standar sistem.",
  "notifications.sessionImportedSuccess": "Sesi Latihan \"{title}\" imported successfully",
  "notifications.teamPlanAssigned": "Rencana tim berhasil ditetapkan",
  "notifications.teamPlanRemoved": "Rencana tim dihapus",
  "notifications.timeHoursAgo": "{hours} jam lalu",
  "notifications.timeJustNow": "Baru saja",
  "notifications.timeMinAgo": "{min} mnt lalu",
  "notifications.timeNow": "Sekarang",
  "notifications.title": "Notifikasi",
  "notifications.weeklyReportReady": "📋 Your weekly team report is ready. Unduh it from the main panel!",
  "page.admin": "ADMINISTRASI",
  "page.dashboard": "DASBOR",
  "page.default": "Mister11",
  "page.equipo": "TIM SAYA",
  "page.ia": "IA GENERADORA",
  "page.partidos": "PERTANDINGAN",
  "page.pizarra": "PAPAN TAKTIK",
  "page.planificacion": "PERENCANAAN",
  "page.sesiones": "SESI LATIHAN",
  "page.tests": "TES & EVALUASI",
  "partidos.tab.analisis": "Analisis",
  "partidos.tab.lista": "Pertandingan",
  "paywall.androidBackToInfo": "Kembali",
  "paywall.androidDialogText": "Subscriptions are centrally managed pada our web platform. Visit mister11.app ke purchase your plan dan get instant access di ini app.",
  "paywall.androidDialogTitle": "Paket Mister11 PRO",
  "paywall.androidHaveCode": "I already have sebuah code",
  "paywall.androidNotNow": "Nanti saja",
  "paywall.androidOpenWeb": "Buka mister11.app",
  "paywall.androidRedeemDesc": "Enter your corporate atau promotional code ke activate your PRO plan instantly.",
  "paywall.androidRedeemTitle": "Tukarkan Kode",
  "paywall.benefit1": "Unlimited latihan sesi",
  "paywall.benefit2": "Generator tugas AI tanpa batas",
  "paywall.benefit3": "Ekspor technical reports in PDF",
  "paywall.benefit4": "Advanced statistics dan metrics suite",
  "paywall.clubBadge": "PAKET KLUB",
  "paywall.freeLimitMsg": "You have reached  free plan limit.",
  "paywall.proBadge": "PAKET PRO",
  "paywall.promoPlaceholder": "Code (e.g. BETA2026)",
  "paywall.promoSectionDesc": "Enter your code (e.g. BETA2026) ke activate access immediately.",
  "paywall.promoSectionTitle": "🔑 Punya kode promo atau uji coba beta?",
  "paywall.title": "Buka Fitur Mister11 Pro",
  "paywall.upgradeBtn": "DAPATKAN PAKET PRO",
  "paywall.upgradeClubBtn": "Lihat Paket KLUB",
  "placeholder.teamName": "e.g. Manchester Youth Sebuah",
  "plan.category": "KATEGORI",
  "plan.categoryPlaceholder": "Cth: U-14 A",
  "plan.chip.compet": "Kompet.",
  "plan.chip.sessions": "Sesi",
  "plan.chip.work": "Kerja",
  "plan.coach": "PELATIH",
  "plan.coachPlaceholder": "Nama pelatih",
  "plan.dateRange": "RENTANG TANGGAL",
  "plan.days.friday": "F",
  "plan.days.monday": "M",
  "plan.days.saturday": "S",
  "plan.days.sunday": "S",
  "plan.days.thursday": "T",
  "plan.days.tuesday": "T",
  "plan.days.wednesday": "W",
  "plan.end": "Selesai",
  "plan.exportPdf": "EKSPOR PDF",
  "plan.fatigaWarning": "⚠️ Latihan di H-1 — potensi kelelahan",
  "plan.matchDay": "⚽ Hari Pertandingan:",
  "plan.meso.backToMeso": "← Kembali ke Mesosiklus",
  "plan.meso.competition": "KOMPETISI",
  "plan.meso.exportPdf": "Ekspor bulan ke PDF",
  "plan.meso.load": "BEBAN",
  "plan.meso.month": "BULAN",
  "plan.meso.monthDetail": "Detail Bulan: ",
  "plan.meso.predominantType": "TIPE DOMINAN",
  "plan.meso.sessions": "SESI",
  "plan.meso.totalVolume": "TOTAL VOLUME",
  "plan.meso.weeks": "Minggu",
  "plan.metricSessions": "SESI",
  "plan.metrics.macrocycle": "MAKROSIKLUS",
  "plan.metrics.mesocycle": "MESOSIKLUS",
  "plan.metrics.mesocyclesOverview": "MESOSIKLUS (IKHTISAR)",
  "plan.micro.matchDayLabel": "🏆 Hari Pertandingan",
  "plan.micro.physical": "Fisik",
  "plan.micro.rest": "Istirahat",
  "plan.micro.selectWeek": "PILIH MINGGU",
  "plan.micro.sessionLabel": "Sesi ({duration} min)",
  "plan.micro.tactical": "Taktis",
  "plan.micro.technical": "Teknis",
  "plan.micro.week": "Minggu",
  "plan.obj.mental": "TUJUAN MENTAL",
  "plan.obj.mentalPlaceholder": "Kembangkan fokus dan kerja sama tim...",
  "plan.obj.physical": "TUJUAN FISIK",
  "plan.obj.physicalPlaceholder": "Meningkatkan daya tahan aerobik dan kecepatan reaksi...",
  "plan.obj.seasonGeneral": "TUJUAN UMUM MUSIM",
  "plan.obj.seasonGeneralPlaceholder": "Jelaskan tujuan utama musim ini...",
  "plan.obj.tactical": "TUJUAN TAKTIS",
  "plan.obj.tacticalPlaceholder": "Menguasai pressing tinggi dan operan membangun serangan...",
  "plan.obj.technical": "TUJUAN TEKNIS",
  "plan.obj.technicalPlaceholder": "Meningkatkan kontrol bola dan umpan di ruang sempit...",
  "plan.pdf.error": "Kesalahan saat mengekspor PDF.",
  "plan.pdf.exported": "PDF diekspor ✓",
  "plan.period.comp": "Komp",
  "plan.period.prep": "Pers",
  "plan.period.trans": "Trans",
  "plan.reschedule.body": "Hari pertandingan yang dipilih untuk minggu ini adalah {day}. Setelah konfirmasi, {count} hari latihan akan disesuaikan secara otomatis untuk menyeimbangkan beban sebelum pertandingan.",
  "plan.reschedule.confirm": "Konfirmasi Penjadwalan Ulang",
  "plan.reschedule.title": "Jadwalkan ulang hari latihan?",
  "plan.reschedule.toastSuccess": "✓ Latihan dijadwalkan ulang berdasarkan hari pertandingan",
  "plan.reubicarBtn": "🔄 Jadwalkan ulang latihan sesuai hari baru",
  "plan.save": "SIMPAN",
  "plan.saving": "MENYIMPAN...",
  "plan.seasonObjective": "TUJUAN UMUM MUSIM",
  "plan.seasonObjectivePlaceholder": "Masukkan tujuan umum musim...",
  "plan.seasonVolume": "VOLUME MUSIM",
  "plan.sessionDuration": "Durasi sesi:",
  "plan.start": "Mulai",
  "plan.strategicPlanning": "PERENCANAAN STRATEGIS",
  "plan.tab.macrociclo": "MAKROSIKLUS",
  "plan.tab.mesociclo": "MESOSIKLUS",
  "plan.tab.microciclo": "MIKROSIKLUS",
  "plan.tab.objetivos": "TUJUAN",
  "plan.totalMinutesLabel": "menit total",
  "plan.trainingDays": "HARI LATIHAN",
  "plan.volumeUnit": "mnt/mgg",
  "planning.generating_pdf": "Menghasilkan PDF mesosiklus...",
  "planning.generating_pdf_generic": "Generando PDF...",
  "planning.login_required": "Masuk untuk menyimpan",
  "planning.matrix.daysPerWeek": "hari/mgg",
  "planning.matrix.loadDynamics": "DINAMIKA BEBAN",
  "planning.matrix.matchDay": "HARI PERTANDINGAN",
  "planning.matrix.microType": "TIPE MIKRO",
  "planning.matrix.microcycleNo": "NO. MIKROSIKLUS",
  "planning.matrix.months": "BULAN",
  "planning.matrix.pctPhysical": "% FISIK",
  "planning.matrix.pctTactical": "% TAKTIS",
  "planning.matrix.pctTechnical": "% TEKNIS",
  "planning.matrix.periods": "PERIODE",
  "planning.matrix.physicalTest": "TES FISIK",
  "planning.matrix.savePlanning": "SIMPAN PERENCANAAN",
  "planning.matrix.sessions": "SESI",
  "planning.matrix.title": "MATRIKS PERENCANAAN",
  "planning.matrix.volumeMin": "VOLUME (MIN)",
  "planning.microType.ajuste": "Penyesuaian",
  "planning.microType.carga": "Beban",
  "planning.microType.choque": "Kejutan",
  "planning.microType.comp": "Komp",
  "planning.microType.recup": "Pemulihan",
  "planning.pdf_error": "Kesalahan Eksporing PDF.",
  "planning.pdf_exported": "PDF exportado ✓",
  "planning.pdf_month_not_found": "Kesalahan: Month Informasi Tidakt found.",
  "planning.pdf_success": "Mesocycle PDF generated Berhasilfully ✓",
  "planning.save_error": "Error al simpan.",
  "planning.saved": "Planning disimpan ✓",
  "plans.assignModal.ageBlocked": "Tidak cocok untuk usia pemain",
  "plans.assignModal.assignBtn": "Tetapkan Rencana",
  "plans.assignModal.frequency": "Frekuensi",
  "plans.assignModal.homeAlternative": "Alternatif rumahan",
  "plans.assignModal.minAge": "Usia min. aman",
  "plans.assignModal.planName": "Nama Rencana (opsional)",
  "plans.assignModal.preferredMaterial": "Peralatan utama",
  "plans.assignModal.reason": "Alasan",
  "plans.assignModal.searchPlaceholder": "Cari latihan...",
  "plans.assignModal.selectExercises": "Pilih Latihan",
  "plans.assignModal.supervisionRequired": "Memerlukan pengawasan langsung",
    "exercise.illustrationPending": "Ilustrasi tertunda — ikuti deskripsi tekstual",
  "exercise.illustrationNotice": "Protokol klinis: validasi teknis visual sedang berjalan tanpa generasi sintetis",
  "exercise.coachingPoints": "Poin-poin kunci pelaksanaan",
  "exercise.minSafeAge": "Usia min. aman",
  "exercise.preferredMaterial": "Peralatan utama",
  "exercise.homeAlternative": "Alternatif rumahan",
  "exercise.supervisionRequired": "Memerlukan pengawasan langsung",
  "plans.assignModal.title": "Tetapkan Rencana Latihan",
  "plans.assignedPlan": "Program Ditugaskan",
  "plans.badgeIndividual": "INDIVIDUAL",
  "plans.badgeTeam": "TEAM",
  "plans.coachFeedback": "Pelatih Instructions",
  "plans.copyLink": "SALIN TAUTAN",
  "plans.daily": "Harian",
  "plans.exercisesHeader": "Today's Latihan",
  "plans.linkCopied": "TAUTAN DISALIN!",
  "plans.loadingPlans": "Memuat Pakets...",
  "plans.noPlansAssigned": "pemain has no assigned plans.",
  "plans.recommendExercises": "Recommend Latihan",
  "plans.routinesAndPrevention": "Routines & Prevention",
  "plans.shareNotice": "Bagikan tautan ini kepada pemain agar mereka dapat melihat program latihan tanpa perlu masuk:",
  "plans.sharePlan": "🔗 Compartir Plan",
  "plans.streakDays.one": "Streak: {count} day",
  "plans.streakDays.other": "Streak: {count} days",
  "player.achievements.bronzeBadge": "25 XP · Tantangan Mingguan",
  "player.achievements.completed": "Selesai!",
  "player.achievements.filterAll": "Semua ({count})",
  "player.achievements.filterBiweekly": "Dua Mingguan (Perak)",
  "player.achievements.filterBronze": "Perunggu ({count})",
  "player.achievements.filterGold": "Emas ({count})",
  "player.achievements.filterSeason": "Musim (Emas)",
  "player.achievements.filterSilver": "Perak ({count})",
  "player.achievements.filterWeekly": "Mingguan (Perunggu)",
  "player.achievements.goldBadge": "100 XP · Tonggak Musim (Maks.)",
  "player.achievements.inProgress": "{percent}% selesai",
  "player.achievements.intentionOnlyNote": "(Tantangan niat)",
  "player.achievements.loading": "Memuat etalase pencapaian...",
  "player.achievements.noSessions": "Tidak ada sesi yang dijadwalkan minggu ini",
  "player.achievements.pendingActa": "Berita acara tertunda",
  "player.achievements.season": "Musim 2026-27 · Sepak Bola Usia Dini",
  "player.achievements.seasonPeriod": "Musim 2026-27",
  "player.achievements.silverBadge": "50 XP · Tantangan Dua Mingguan",
  "player.achievements.subtabJuegos": "Permainan & Tantangan",
  "player.achievements.subtabRanking": "Peringkat",
  "player.achievements.subtabVitrina": "Etalase",
  "player.achievements.thisFortnight": "Dua minggu ini",
  "player.achievements.thisWeek": "Minggu ini",
  "player.achievements.tierBronze": "Perunggu",
  "player.achievements.tierGold": "Emas",
  "player.achievements.tierSilver": "Perak",
  "player.achievements.title": "Pencapaian Olahraga Anda",
  "player.achievements.titleParent": "Pencapaian dari {nama}",
  "player.achievements.unlocked": "Terbuka",
  "player.achievements.xpSubtitle": "Diperoleh dengan membuka tantangan",
  "player.achievements.xpTitle": "XP Pencapaian",
  "player.addPlayer": "+ Add Pemain",
  "player.age": "Usia",
  "player.assists": "Asistencias",
  "player.attendance.absent": "Absen",
  "player.attendance.excused": "Izin",
  "player.attendance.injured": "Cedera",
  "player.attendance.monthlyTitle": "Monthly Attendance Record",
  "player.attendance.present": "Hadir",
  "player.attendance.rate": "Annual Attendance Rate",
  "player.avgRating": "Nota Rata-rata",
  "player.bmi": "BMI",
  "player.bothFeet": "Keduanya",
  "player.cards": "Tarjetas",
  "player.category": "Kategori",
  "player.chat.block.btn": "Yes, Block",
  "player.chat.block.confirm": "Are you sure you want ke block communication dengan {nama}? Neither party will be able ke send private messages until unblocked.",
  "player.chat.block.success": "Pengguna blocked Berhasilfully.",
  "player.chat.block.title": "Block user?",
  "player.chat.block_error": "Kesalahan blocking Pengguna.",
  "player.chat.blocked.banner": "🚫 Communication di ini private chat is blocked.",
  "player.chat.blocked.unblockHint": "You can manage blocked users di Profile > Privacy.",
  "player.chat.coachSender": "👑 Pelatihing Staff",
  "player.chat.emptyDesc": "Send sebuah message atau tap one of  quick replies above.",
  "player.chat.emptyTitle": "No messages di ini channel yet.",
  "player.chat.headerSubtitle": "{tim} · Private dan confidential messages",
  "player.chat.headerTitle": "Direct Channel dengan Coaching Staff",
  "player.chat.loading": "Memuat conversation...",
  "player.chat.menu.block": "Bloquear usuario",
  "player.chat.menu.copied": "Text copied ke clipboard",
  "player.chat.menu.copy": "Copiar texto",
  "player.chat.menu.report": "Denunciar mensaje",
  "player.chat.moderation.badge": "Reportes",
  "player.chat.moderation.deleteConfirm": "Permanently hapus ini message dari  chat?",
  "player.chat.moderation.deleteMsg": "Hapus message",
  "player.chat.moderation.empty": "No tertunda reported messages.",
  "player.chat.moderation.msgDeleted": "Message dihapus dari chat.",
  "player.chat.moderation.resolve": "Marcar como resuelto",
  "player.chat.moderation.resolved": "Laporan marked as resolved.",
  "player.chat.moderation.title": "Message Moderation",
  "player.chat.now": "Ahora",
  "player.chat.optionsAria": "Opsi pesan",
  "player.chat.placeholder": "Write sebuah message ke  pelatih...",
  "player.chat.placeholderCoach": "Write sebuah reply ke {nama}...",
  "player.chat.playerSender": "👤 Pemain",
  "player.chat.qr.coachEarly": "⏰ Remember ke arrive 15 min early",
  "player.chat.qr.coachReceived": "👍 Received, see you pada  pitch",
  "player.chat.qr.coachRest": "🩺 Rest dan let me know if pain persists",
  "player.chat.qr.coachSquad": "📋 Squad confirmed, all  best!",
  "player.chat.qr.discomfort": "🩺 I have muscle Nyeri Otot",
  "player.chat.qr.late10": "🏃 Llego 10 min tarde",
  "player.chat.qr.ready": "✅ All set untuk  pertandingan",
  "player.chat.qr.talk": "❓ Coach, can I speak dengan you?",
  "player.chat.qr.transport": "🚗 I need transport untuk  away pertandingan",
  "player.chat.quickMsg.injury": "I have sebuah muscle discomfort dan cannot train di 100%.",
  "player.chat.quickMsg.late": "I will be 5 menit late.",
  "player.chat.quickMsg.ready": "Ready untuk ini weekend pertandingan!",
  "player.chat.quickMsg.study": "I cannot attend due ke study / exam commitments.",
  "player.chat.quickReplies": "⚡ Quick replies:",
  "player.chat.quickTitle": "Quick Messages:",
  "player.chat.report.detailsPlaceholder": "Tambah any Tambahitional Detail (Opsial)...",
  "player.chat.report.quotedMessage": "Laporaned message:",
  "player.chat.report.reason.harassment": "Harassment, bullying atau misconduct",
  "player.chat.report.reason.inappropriate": "Inappropriate content atau offensive bahasa",
  "player.chat.report.reason.other": "Otro motivo",
  "player.chat.report.reason.spam": "Spam atau unwanted messages",
  "player.chat.report.selectReason": "Pilih alasan:",
  "player.chat.report.submit": "Enviar Denuncia",
  "player.chat.report.submitting": "Enviando...",
  "player.chat.report.subtitle": "We review all reports ke ensure sebuah safe dan respectful environment.",
  "player.chat.report.success": "Report submitted successfully. Staff will review ini message.",
  "player.chat.report.title": "Denunciar Mensaje",
  "player.chat.report_error": "Kesalahan Kiriming Laporan.",
  "player.chat.send": "Enviar",
  "player.chat.sendAria": "Enviar mensaje",
  "player.chat.title": "Chat with Coach",
  "player.chat.unblock.btn": "Desbloquear",
  "player.chat.unblock.confirm": "Do you want ke unblock {nama} dan resume messaging?",
  "player.chat.unblock.success": "Usuario desbloqueado.",
  "player.closeProfile": "Tutup profile",
  "player.coachRating": "Coach Rating",
  "player.deleteConfirm": "Apakah Anda yakin ingin menghapus pemain ini dari skuad?",
  "player.deleteFromTeam": "Hapus {name} dari Tim",
  "player.editProfile": "Editar Ficha",
  "player.foot": "Kaki dominan",
  "player.foot.both": "Kedua Kaki",
  "player.foot.left": "Kiri",
  "player.foot.right": "Kanan",
  "player.goalAbbr": "GOL",
  "player.goals": "GOL",
  "player.height": "Tinggi Badan",
  "player.heightAbbr": "Tinggi",
  "player.home.almostBronze": "PENCAPAIAN HAMPIR TERCAPAI! (PERUNGGU)",
  "player.home.almostGold": "PENCAPAIAN HAMPIR TERCAPAI! (EMAS)",
  "player.home.almostSilver": "PENCAPAIAN HAMPIR TERCAPAI! (PERAK)",
  "player.home.announcements": "Tim Notice Board",
  "player.home.closestAchievement": "Next Challenge",
  "player.home.goals": "MATCH GOALS",
  "player.home.goalsSub": "{goals} di {pertandingan} ({menit}')",
  "player.home.goalsSummary": "{goals} di {pertandingan} ({menit}')",
  "player.home.greeting": "Halo, {name}!",
  "player.home.nextChallenge": "NEXT CHALLENGE",
  "player.home.nextEventBadge": "NEXT CALL-UP",
  "player.home.nextMatch": "Next Call-up",
  "player.home.noAnnouncements": "Tidak ada pengumuman terbaru dari pelatih.",
  "player.home.noUpcoming": "No latihan sesi scheduled untuk  coming days.",
  "player.home.rsvpBtn": "Konfirmasi Attendance (RSVP)",
  "player.home.rsvpPrompt": "Apakah Anda akan menghadiri sesi ini?",
  "player.home.scheduled": "PROGRAMADO",
  "player.home.soon": "Coming soon",
  "player.home.streak": "ATTENDANCE STREAK",
  "player.home.streakSession": "{count} consecutive sesi",
  "player.home.streakSessions": "{count} consecutive sesi",
  "player.home.streakSub": "{count} di sebuah row",
  "player.home.subtitle": "Everything set untuk your next latihan.",
  "player.home.viewDetails": "Lihat Detalles",
  "player.home.viewSchedule": "Ver Calendario Completo",
  "player.leaderboard.accumulatedXP": "{xp} XP acumulados",
  "player.leaderboard.challenges": "retos",
  "player.leaderboard.colMetric": "METRIC",
  "player.leaderboard.colPlayer": "TEAMMATE",
  "player.leaderboard.colRank": "RANK",
  "player.leaderboard.colXP": "XP TOTAL",
  "player.leaderboard.footerDesc": "Commitment di latihan dan teamwork are  path ke rank up di Mister11.",
  "player.leaderboard.footerTitle": "Every sesi counts untuk  tim!",
  "player.leaderboard.leadingTeam": "👑 Leading tim standings!",
  "player.leaderboard.matchesPlayedShort": "MP",
  "player.leaderboard.protectedData": "Protected tim data",
  "player.leaderboard.subtitle": "Earn XP dengan your latihan attendance, menit played dan selesai challenges.",
  "player.leaderboard.tabAchievements": "Logros",
  "player.leaderboard.tabAttendance": "Kehadiran",
  "player.leaderboard.tabGlobal": "Global XP",
  "player.leaderboard.tabMatches": "Pertandingan & Minutes",
  "player.leaderboard.tierTag": "Rango {tier}",
  "player.leaderboard.title": "Tim PERFORMANCE LEADERPapan",
  "player.leaderboard.xpDiff": "Only {xp} XP away dari Top #{rank}!",
  "player.leaderboard.youChip": "YOU",
  "player.leaderboard.yourRank": "Your Position:",
  "player.leftFoot": "Kiri",
  "player.linkedAccount": "Akun Terhubung",
  "player.matchHistory": "Pertandingan History",
  "player.matchHistoryEmpty": "No pertandingan recorded untuk ini pemain.",
  "player.matches": "PERTANDINGAN",
  "player.matchesAbbr": "MP",
  "player.minutes": "MENIT",
  "player.minutesPlayed": "Minutes played",
  "player.nav.achievements": "Logros",
  "player.nav.chat": "Coach",
  "player.nav.home": "Beranda",
  "player.nav.profile": "Ficha",
  "player.nav.schedule": "Agenda",
  "player.nav.stats": "Stats",
  "player.nav.tests": "Tes",
  "player.noAccount": "Tidak ada akun (edit profil untuk menambahkan)",
  "player.noLinkedAccount": "Tanpa akun tertaut",
  "player.notifications.promptBtn": "ACTIVAR AVISOS",
  "player.notifications.promptDesc": "Instantly get official pertandingan squads dan reminders two hours before each practice.",
  "player.notifications.promptLater": "Later",
  "player.notifications.promptTitle": "Would you like ke turn pada squad dan pertandingan alerts?",
  "player.openChat": "Open Chat dengan pemain",
  "player.plans.completeExercise": "Mark as selesai",
  "player.plans.completedExercise": "Latihan completed!",
  "player.plans.error": "Error",
  "player.plans.noPlans": "Anda belum memiliki rencana aktif yang ditugaskan",
  "player.plans.posturalKey": "Clave Postural",
  "player.plans.prevention": "Injury Prevention",
  "player.plans.reps": "Repeticiones",
  "player.plans.rest": "Descanso",
  "player.plans.sets": "Series",
  "player.plans.stepByStep": "STEP-BY-STEP EXECUTION",
  "player.plans.subtitle": "Custom routines assigned oleh coaching staff",
  "player.plans.title": "Individual Pelatihan Pakets",
  "player.portal.activeCard": "Ficha activa:",
  "player.portal.family": "PORTAL FAMILIA",
  "player.portal.joinWithCode": "Gabung ke Tim dengan Kode",
  "player.portal.loading": "Loading your pemain portal...",
  "player.portal.logoutAria": "Log Out atau Switch Account",
  "player.portal.myTeam": "Tim Saya",
  "player.portal.notLinkedDesc": "You are not linked ke any tim as sebuah pemain yet. Ask your pelatih untuk  access code atau tap below ke join your squad.",
  "player.portal.notLinkedTitle": "Halo, {name}!",
  "player.portal.parentView": "Parent View",
  "player.portal.player": "PLAYER PORTAL",
  "player.portal.selectTeamAria": "Select pemain tim",
  "player.portal.settingsAria": "Pengaturan & Preferences",
  "player.portal.switchToCoach": "Switch ke Coach Mode",
  "player.portal.themeDarkAria": "Switch ke dark mode",
  "player.portal.themeLightAria": "Switch ke light mode",
  "player.primaryPosition": "Posisi Utama",
  "player.profile.account": "Access Account",
  "player.profile.account_deleted": "Your akun has been dihapus successfully.",
  "player.profile.activeCard": "Active Pemain:",
  "player.profile.age": "Edad",
  "player.profile.attendance": "ATTENDANCE",
  "player.profile.blockedUsers": "Usuarios Bloqueados",
  "player.profile.bmi": "BMI",
  "player.profile.bodyComp": "📊 Body Composition",
  "player.profile.bodyCompDesc": "Anthropometric parameters are monitored periodically oleh  coaching staff ke optimize your fitness plan.",
  "player.profile.category": "Category",
  "player.profile.consentClearSign": "Borrar firma",
  "player.profile.consentDrawLabel": "Parent / Guardian Signature (touch atau mouse):",
  "player.profile.consentHealthCheck": "Health & Wellness Data: I authorize daily wellness check-ins dan muscle soreness tracking solely untuk injury prevention purposes.",
  "player.profile.consentModalDesc": "In accordance dengan  GDPR,  parent atau legal guardian can authorize atau deny  following data processing untuk  minor:",
  "player.profile.consentModalTitle": "Consentimiento Parental Digital",
  "player.profile.consentParentNameLabel": "Nama Lengkap Orang Tua / Wali *",
  "player.profile.consentPending": "Tertunda Signature",
  "player.profile.consentSaveSign": "Konfirmasi and Simpan Signature",
  "player.profile.consentSaving": "Menyimpan...",
  "player.profile.consentSigned": "Signed dan Valid",
  "player.profile.consentStatus": "Parental Consent Status",
  "player.profile.consentTestsCheck": "Tests & Performance: I authorize autonomous fitness testing (speed, jump, endurance) untuk technical tracking.",
  "player.profile.consent_error": "Kesalahan saving consent.",
  "player.profile.consent_saved": "Parental consent updated Berhasilfully.",
  "player.profile.deleteAccount": "Hapus Account & Data (GDPR)",
  "player.profile.deleteAccountDesc": "This action is permanent dan irreversible. Your user access, sports history, consents, dan profil di Mister11 will be dihapus.",
  "player.profile.deleteAccountTitle": "Hapus your account?",
  "player.profile.deleteConfirmBtn": "Yes, Hapus Account",
  "player.profile.deleteConfirmPrompt": "Type DELETE ke konfirmasi:",
  "player.profile.deleteConfirmWord": "HAPUS",
  "player.profile.deleteDeleting": "Eliminando...",
  "player.profile.discomfortQuestion": "2. Do you have any discomfort atau muscle pain?",
  "player.profile.discomfortZone": "Zona ketidaknyamanan:",
  "player.profile.dorsal": "DORSAL",
  "player.profile.foot": "Pie dominante",
  "player.profile.general": "GENERAL",
  "player.profile.goals": "Goals",
  "player.profile.hasDiscomfort": "🟡 Tengo molestias",
  "player.profile.health": "HEALTH",
  "player.profile.height": "Altura",
  "player.profile.logout": "Cerrar Sesi",
  "player.profile.matches": "Pertandingan",
  "player.profile.minutes": "Minutes",
  "player.profile.moodQuestion": "3. Mood dan energy level today? (1 = Low, 5 = Peak)",
  "player.profile.noBlockedUsers": "You do Tidakt have any blocked Penggunas.",
  "player.profile.noDiscomfort": "🟢 Tidak discomfort",
  "player.profile.parentBadge": "Vista Familiar / Tutor",
  "player.profile.parent_name_required": "Please enter  parent/guardian nama.",
  "player.profile.physical": "PHYSICAL",
  "player.profile.plans": "PLANS",
  "player.profile.position": "Main Position",
  "player.profile.sendWellness": "Simpan Health Check-in",
  "player.profile.signConsent": "Firmar / Editar Consentimiento",
  "player.profile.sleepQuestion": "1. Bagaimana tidur dan pemulihan Anda? (1 = Sangat buruk, 5 = Sangat baik)",
  "player.profile.switchToCoach": "Switch ke Coach Mode",
  "player.profile.weight": "Peso",
  "player.profile.wellnessCheckin": "DAILY Kebugaran CHECK-IN",
  "player.profile.wellnessSent": "You have already submitted today's check-di! You can perbarui it if your feelings change.",
  "player.profile.wellness_saved": "Wellness check-di disimpan successfully!",
  "player.profile.years": "years old",
  "player.rightFoot": "Kanan",
  "player.schedule.attendance_error": "Kesalahan saving attendance.",
  "player.schedule.backToCurrentMonth": "Kembali to current month",
  "player.schedule.calledBadge": "📋 Convocado",
  "player.schedule.calledUp": "Dipanggil",
  "player.schedule.calledUpDesc": "Anda telah dipilih oleh staf pelatih. Berikan 100% di lapangan!",
  "player.schedule.coachRating": "Nilai Pelatih:",
  "player.schedule.emptyDesc": "Your pelatih has not scheduled sesi atau pertandingan untuk ini month yet.",
  "player.schedule.match": "MATCH",
  "player.schedule.minPlayed": "min jugados",
  "player.schedule.noEvents": "No events scheduled untuk ini month.",
  "player.schedule.noMinutes": "Tanpa menit bermain",
  "player.schedule.notCalled": "Not called up untuk ini pertandingan",
  "player.schedule.notCalledDesc": "Tetap semangat dan terus berlatih keras!",
  "player.schedule.pendingVerification": "Tertunda verification",
  "player.schedule.promptParent": "Will {nama} attend ini event?",
  "player.schedule.promptSelf": "Will you attend ini sesi?",
  "player.schedule.reserve": "Standby / Reserve list",
  "player.schedule.reserveDesc": "Tetap siap jika ada perubahan menit terakhir.",
  "player.schedule.rsvpConfirmed": "Attendance Konfirmasied: \"{Status}\"",
  "player.schedule.rsvpGoing": "Going",
  "player.schedule.rsvpJustified": "Izin",
  "player.schedule.rsvpLate": "Arriving late",
  "player.schedule.rsvpNotGoing": "Not going",
  "player.schedule.starter": "Starter",
  "player.schedule.substitute": "Pemain Pengganti",
  "player.schedule.title": "Tim Schedule",
  "player.schedule.training": "TRAINING",
  "player.settings.dangerZone": "Privacy Zone (GDPR)",
  "player.settings.deleteAccountDesc": "Permanently hapus your profil dan personal records.",
  "player.settings.installApp": "Pasang Aplikasi (PWA)",
  "player.settings.installAppDesc": "Add Mister11 ke your home screen untuk fast native access.",
  "player.settings.language": "Bahasa Aplikasi",
  "player.settings.modalTitle": "Pengaturan & Preferences",
  "player.settings.notifications": "Sesi Latihan Reminders",
  "player.settings.notificationsDesc": "Receive reminders 1 hour before latihan dan pertandingan.",
  "player.settings.sessionTitle": "Sesi Latihan & Account",
  "player.settings.switchModeTitle": "Peran & Permissions",
  "player.settings.theme": "Modo Oscuro",
  "player.shareConsent": "Bagikan Izin Orang Tua",
  "player.starter": "Titular",
  "player.stats.aboveAvg": "▲ +{xp} XP (Above Rata-rata)",
  "player.stats.anonymousRgpd": "🔒 ATidaknymous data (GDPR)",
  "player.stats.areasInZero": "Areas tertunda measurement",
  "player.stats.areasInZeroDesc": "Mental area is activated oleh completing questionnaires di  Tests tab. Physical, Technical, dan Tactical areas are updated dengan pelatih evaluations.",
  "player.stats.assists": "ASISTENCIAS",
  "player.stats.average": "Rata-rata:",
  "player.stats.avgRating": "NOTA MEDIA",
  "player.stats.axis.attendance": "ATTENDANCE",
  "player.stats.axis.mental": "MENTAL",
  "player.stats.axis.physical": "PHYSICAL",
  "player.stats.axis.tactical": "TACTICAL",
  "player.stats.axis.technical": "TECHNICAL",
  "player.stats.belowAvg": "▼ +{xp} XP (BeRendah Rata-rata)",
  "player.stats.cards": "CARDS",
  "player.stats.disciplinarySanctions": "Sanciones disciplinarias",
  "player.stats.evolutionTitle": "Test Evolution Over Time",
  "player.stats.friendlyMatch": "Persahabatan",
  "player.stats.globalXpSubtitle": "Attendance + menit + achievements",
  "player.stats.globalXpTitle": "XP Global",
  "player.stats.goToTests": "Go ke Questionnaires",
  "player.stats.goals": "GOALS",
  "player.stats.hideGuide": "Hide guide",
  "player.stats.hideInfo": "Ocultar info",
  "player.stats.howAxesMeasured": "How is each axis measuMerah?",
  "player.stats.howIsMeasured": "How is ini measured?",
  "player.stats.howIsMeasuredDesc": "Attendance dan menit are extracted dari official pertandingan sheets di strict compliance dengan GDPR.",
  "player.stats.inCompetition": "in competition",
  "player.stats.inMatch": "di {count} pertandingan",
  "player.stats.inMatches": "di {count} pertandingan",
  "player.stats.keyPasses": "umpan kunci",
  "player.stats.leaderboardSubtitle": "Score dan commitment di  locker room",
  "player.stats.leaderboardTitle": "Squad LeaderPapan",
  "player.stats.makeTest": "Hacer test",
  "player.stats.matchHistory": "OFFICIAL Pertandingan HISTORY",
  "player.stats.matchHistorySync": "Synced dengan pelatih pertandingan sheets",
  "player.stats.minutesPerMatch": "Minutes per pertandingan",
  "player.stats.minutesPlayed": "MINUTES",
  "player.stats.noAttRecorded": "● No sesi recorded yet",
  "player.stats.noEvalsDesc": "Complete tests di  Tests tab atau wait untuk pelatih assessments ke see your progression charts.",
  "player.stats.noEvalsYet": "Tidak evaluations recorded yet",
  "player.stats.noMatchesDesc": "Your menit, goals, dan call-ups will appear here automatically after each pertandingan.",
  "player.stats.noMatchesRecorded": "● No pertandingan played yet",
  "player.stats.noMatchesYet": "No pertandingan recorded yet ini season",
  "player.stats.noTeamDataDesc": "Comparative metrics will automatically activate when pelatih logs attendance atau pertandingan.",
  "player.stats.noTeamDataYet": "● Tidakt eTidakugh squad data yet",
  "player.stats.officialMatch": "Resmi",
  "player.stats.officialMatches": "PERTANDINGAN",
  "player.stats.officialRating": "Nota Rata-rata Oficial",
  "player.stats.officialSummaryTitle": "OFFICIAL STATS 2026-27",
  "player.stats.onAvg": "● +{xp} XP (On Rata-rata)",
  "player.stats.pendingActaShort": "Pending pertandingan sheet",
  "player.stats.radarAtt": "Attendance: Real attendance rate dari latihan sesi dan call-ups.",
  "player.stats.radarGuideTitle": "Data source untuk each dimension (0 ke 100):",
  "player.stats.radarLevel": "Global Level: {Level}",
  "player.stats.radarMental": "Mental: Psychological questionnaires (ACSI-28, MTQ-10), cognitive game latihan dan coaching staff rating.",
  "player.stats.radarPhys": "Physical: Fitness tests (endurance, speed, power) atau pelatih physical grade.",
  "player.stats.radarTact": "Tactical: Positioning, decision making dan game reading evaluated oleh pelatih.",
  "player.stats.radarTech": "Technical: Ball control, passing, dribbling dan finishing evaluated oleh pelatih.",
  "player.stats.radarTitle": "SKILLS RADAR",
  "player.stats.realTime": "⚡ In real time",
  "player.stats.seasonAverage": "Season average",
  "player.stats.sourceAttendance": "Attendance: Sourced dari official pelatih latihan logs. Grants +{xp} XP based pada your attendance rate.",
  "player.stats.sourceAverage": "Squad Average: Locker room benchmark ke assess your consistency tanpa negative bias.",
  "player.stats.sourceInfoTitle": "Where do  data dan XP points di ini table come dari?",
  "player.stats.sourceMatches": "Pertandingan / Minutes: Sourced from official match sheets and call-ups. Grants +{xp} XP proportional to your minutes played.",
  "player.stats.startsAndSubs": "{starts} tit. · {subs} sup.",
  "player.stats.title": "Stats & Performance",
  "player.stats.vsTeamTitle": "YOU VS Tim Rata-rata",
  "player.stats.wellnessTitle": "Bienestar Semanal (Wellness)",
  "player.stats.xpByParticipation": "+{xp} XP based pada your {pct}% participation",
  "player.stats.you": "Anda",
  "player.substitute": "Cadangan",
  "player.syncNotice": "Goals, lineups, and minutes recorded in the Pertandingan module will automatically synchronize here.",
  "player.tab.attendance": "KEHADIRAN",
  "player.tab.chat": "OBROLAN",
  "player.tab.general": "UMUM",
  "player.tab.health": "KESEHATAN",
  "player.tab.physical": "FISIK",
  "player.tab.plans": "PROGRAM",
  "player.tab.settings": "PENGATURAN",
  "player.weight": "Berat Badan",
  "playerDashboard.new_message": "💬 New message dari Coach:",
  "playerProfile.ageLabel": "Usia",
  "playerProfile.bmi": "BMI",
  "playerProfile.bmiDesc": "Perkiraan Body Mass Index.",
  "playerProfile.editTooltip": "Tap ke edit your measurements",
  "playerProfile.heightLabel": "Tinggi Badan",
  "playerProfile.heightRangeError": "Height must be between 100 dan 230 cm.",
  "playerProfile.heightUnit": "cm",
  "playerProfile.physicalStats": "Data Fisik",
  "playerProfile.readOnlyNotice": "Age, shirt number dan position can only be modified oleh coaching staff.",
  "playerProfile.saveError": "Kesalahan saving Fisik stats.",
  "playerProfile.statsSaved": "Fisik stats updated Berhasilfully.",
  "playerProfile.weightLabel": "Peso",
  "playerProfile.weightRangeError": "Weight must be between 30 dan 150 kg.",
  "playerProfile.weightUnit": "kg",
  "pos.all": "ALL",
  "pos.def": "DEF",
  "pos.del": "ST",
  "pos.ext": "W",
  "pos.ltd": "RB",
  "pos.lti": "LB",
  "pos.mc": "CM",
  "pos.mcd": "CDM",
  "pos.mco": "CAM",
  "pos.por": "GK",
  "pricing.badge.bestValueAcademies": "PILIHAN TERBAIK AKADEMI",
  "pricing.badge.mostPopularCoach": "PILIHAN UTAMA PELATIH",
  "pricing.billing.discountBadge": "2 BULAN GRATIS",
  "pricing.billing.monthly": "Bulanan",
  "pricing.billing.season": "Tiket Musim Penuh (10 Bulan)",
  "pricing.btn.selectClubPro": "PILIH CLUB PRO",
  "pricing.btn.selectPremium": "PILIH PREMIUM",
  "pricing.btn.selectStarter": "PILIH STARTER",
  "pricing.btn.startFree": "MULAI GRATIS",
  "pricing.btn.tryPro": "COBA 7 HARI GRATIS",
  "pricing.cancelAnytime": "Batalkan kapan saja tanpa komitmen.",
  "pricing.clubPro.attr1_strong": "Hingga 15 Tim",
  "pricing.clubPro.attr1_text": "Hingga 10 staf per tim",
  "pricing.clubPro.attr2_strong": "Laporan Terpadu Klub",
  "pricing.clubPro.attr3_strong": "Riwayat Akademi Global & Dukungan 24/7",
  "pricing.clubPro.vat": "~3,00 €/pelatih/bulan · Termasuk PPN",
  "pricing.coachPro": "Pelatih PRO",
  "pricing.comparison.subtitle": "Analisis setiap fitur secara mendalam antara paket individu dan klub dengan hak akses terverifikasi.",
  "pricing.comparison.thModule": "Modul dan Fitur",
  "pricing.comparison.title": "Matriks Perbandingan Fitur Terperinci",
  "pricing.footer.install": "Pasang Aplikasi / PWA",
  "pricing.footer.login": "Masuk Pelatih",
  "pricing.footer.rgpd": "GDPR & Privasi",
  "pricing.footer.rights": "Semua hak dilindungi undang-undang. Palet Resmi Tanah dan Lapangan.",
  "pricing.footer.tagline": "Platform kecerdasan teknis untuk sepak bola usia muda dan amatir.",
  "pricing.free.attr1_strong": "1 Tim",
  "pricing.free.attr1_text": "(23 pemain) · 1 Pelatih",
  "pricing.free.attr2_strong": "10 Sesi",
  "pricing.free.attr2_text": "Papan taktik dasar · 5 AI/bulan",
  "pricing.free.attr3_strong": "Tanda Tangan Digital GDPR",
  "pricing.free.attr3_text": "disertakan",
  "pricing.freq.forever": "/ selamanya",
  "pricing.freq.month": "/ bulan",
  "pricing.freq.season": "/ musim",
  "pricing.freq.seasonShort": "/ musim",
  "pricing.fullAccess": "Akses penuh ke semua fitur lanjutan.",
  "pricing.header.subtitle": "Harga sudah termasuk PPN. Tiket musim mencakup 10 bulan kompetisi resmi dengan Juli dan Agustus gratis.",
  "pricing.header.title": "Paket Transparan untuk Pelatih dan Klub",
  "pricing.monthly": "Tagihan bulanan",
  "pricing.plan.clubPremium.name": "Club Premium",
  "pricing.plan.clubPremium.tagline": "Untuk akademi berkinerja tinggi dan multi-cabang",
  "pricing.plan.clubPro.name": "Club PRO",
  "pricing.plan.clubPro.tagline": "Untuk klub terstruktur dengan metodologi sendiri",
  "pricing.plan.clubStarter.name": "Club Starter",
  "pricing.plan.clubStarter.tagline": "Untuk pembinaan usia muda dan klub berkembang",
  "pricing.plan.free.name": "Paket Gratis",
  "pricing.plan.free.tagline": "Untuk mulai mendigitalisasi tim Anda",
  "pricing.plan.pro.name": "Paket PRO",
  "pricing.plan.pro.tagline": "Untuk pelatih yang menginginkan performa maksimal",
  "pricing.premium.attr1_strong": "Hingga 40 Tim",
  "pricing.premium.attr1_text": "Staf Tanpa Batas",
  "pricing.premium.attr2_strong": "Lisensi Multi-Lokasi dan Kode Akses",
  "pricing.premium.attr3_strong": "Pendampingan Khusus dan Dukungan VIP",
  "pricing.premium.vat": "Termasuk PPN · Dukungan VIP",
  "pricing.pro.attr1_strong": "Hingga 3 Tim",
  "pricing.pro.attr1_text": "Sesi latihan tanpa batas & Live Stats",
  "pricing.pro.attr2_strong": "Laporan Resmi PDF 7 Halaman",
  "pricing.pro.attr2_text": "xG-Lite (105:68) & Metrik Kiper",
  "pricing.pro.attr3_strong": "Portal Pemain",
  "pricing.pro.attr3_text": "Wellness harian, Tes & AI tanpa batas",
  "pricing.pro.vatMonthly": "Ditagih bulanan · Batalkan kapan saja",
  "pricing.pro.vatSeason": "Setara 6,90 €/bulan · Termasuk PPN",
  "pricing.starter.attr1_strong": "Hingga 6 Tim",
  "pricing.starter.attr1_text": "Hingga 4 staf per tim",
  "pricing.starter.attr2_strong": "Semua fitur Paket PRO disertakan",
  "pricing.starter.attr3_strong": "Panel Multi-Pelatih dengan Peran",
  "pricing.starter.vat": "~5,50 €/pelatih/bulan · Termasuk PPN",
  "pricing.subscribeNow": "Berlangganan Sekarang",
  "pricing.vat.included": "Termasuk PPN",
  "push.foreground_toast": "🔔 Notifikasi {title}: {body}",
  "qrScanner.cameraPermissionError": "Could Tidakt Akses camera. Please check browser permissions.",
  "qrScanner.hint": "Point your camera di  QR code provided oleh  pelatih ke join  tim automatically.",
  "qrScanner.noQrInImage": "No QR code detected di  selected image.",
  "qrScanner.title": "Scan Tim QR Code",
  "qrScanner.unsupportedBrowser": "Your browser atau device does not dukungan camera access.",
  "qrScanner.uploadQrPhoto": "Upload QR photo",
  "rendimientoPdf.btnDownload": "Unduh PDF",
  "rendimientoPdf.chartsTitle": "Pemain Metrics Comparison",
  "rendimientoPdf.generatedBy": "Generated oleh Mister11",
  "rendimientoPdf.matchDetails": "Rincian Pertandingan",
  "rendimientoPdf.subtitle": "Individual pemain statistics dan canonical metrics",
  "rendimientoPdf.tableTitle": "Lengkap Performance Table",
  "rendimientoPdf.title": "INDIVIDUAL PERFORMANCE Laporan",
  "sector.activeZone": "Aktif Zone: {zone}",
  "sesiones.actions.edit": "Editar",
  "sesiones.actions.share": "Compartir",
  "sesiones.blockCount.one": "{count} Bloque",
  "sesiones.blockCount.other": "{count} Bloques",
  "sesiones.categories.all": "Todas",
  "sesiones.categories.fisica": "Fisik",
  "sesiones.categories.general": "General",
  "sesiones.categories.mixta": "Mixta",
  "sesiones.categories.partido": "Pertandingan",
  "sesiones.categories.tactica": "Taktik",
  "sesiones.categories.tecnica": "Teknik",
  "sesiones.clickDayToView": "Click sebuah day ke view sesi",
  "sesiones.exportICS": "📅 Ekspor ICS",
  "sesiones.fieldMode": "Modo Campo",
  "sesiones.importSession": "Impor Sesi Latihan",
  "sesiones.newSession": "Buat Sesi Baru",
  "sesiones.noDiagram": "Sin diagrama",
  "sesiones.preview.addBlock": "+ Add Block",
  "sesiones.preview.blocks": "BLOCKS",
  "sesiones.preview.deleteAnimation": "HAPUS",
  "sesiones.preview.deleteSession": "Hapus Sesi Latihan",
  "sesiones.preview.editSession": "✏️ Edit Sesi Latihan",
  "sesiones.preview.emptyBlocks": "Tidak blocks defined.",
  "sesiones.preview.exportMp4": "🎬 EXPORTAR MP4",
  "sesiones.preview.exportPdf": "📄 Ekspor to PDF",
  "sesiones.preview.generating": "⏳ Generating Laporan...",
  "sesiones.preview.googleCal": "📅 Google Cal",
  "sesiones.preview.ics": "📥 ICS",
  "sesiones.preview.load": "LOAD",
  "sesiones.preview.min": "MIN",
  "sesiones.preview.shareSession": "🔗 Share / Transfer Sesi Latihan",
  "sesiones.preview.startLiveField": "⏱️ Start Live Lapangan Mode (Timer & Voice)",
  "sesiones.preview.structure": "Sesi Latihan Structure",
  "sesiones.preview.viewPdf": "Lihat PDF",
  "sesiones.tab.animations": "Animaciones",
  "sesiones.tab.captures": "Capturas",
  "sesiones.tab.sessions": "Sesi Latihan",
  "sesiones.title": "Sesi Latihan",
  "sesiones.views.day": "DAY",
  "sesiones.views.month": "MONTH",
  "sesiones.views.week": "WEEK",
  "session.untitled": "Tanpa judul",
  "sessionRating.averageRating": "Rata-rata",
  "sessionRating.commentPlaceholder": "Coaching notes atau feedback (optional, max 200 chars)",
  "sessionRating.evolutionTitle": "Pelatihan Evolution",
  "sessionRating.noRatings": "No ratings recorded untuk ini sesi yet.",
  "sessionRating.performanceTableSubtitle": "Last 5 rated sesi dan accumulated average",
  "sessionRating.performanceTableTitle": "Performa Latihan",
  "sessionRating.radarAxisTraining": "Latihan",
  "sessionRating.rateButton": "Calificar",
  "sessionRating.ratingLabel": "Nota",
  "sessionRating.saveError": "Error saving sesi ratings.",
  "sessionRating.saveRatings": "Simpan Ratings",
  "sessionRating.savedSuccess": "Penilaian sesi berhasil dicatat.",
  "sessionRating.subtitle": "Rate performance of called-up pemain (0 ke 10)",
  "sessionRating.title": "Penilaian Pasca Latihan (RPE)",
  "settings.teamIdentity": "Tim Identity",
  "shot.badge_decisive": "DECISIVA",
  "shot.badge_normal": "NORMAL",
  "shot.blocked": "Tembakan Diblok",
  "shot.cancel": "Batal",
  "shot.comfort": "Kenyamanan Penembak",
  "shot.comfort_comfortable": "Comfortable",
  "shot.comfort_pressed": "Presionado",
  "shot.comfort_very_pressed": "Muy Presionado",
  "shot.confirm": "Registrar Tiro",
  "shot.diff_decisive": "Decisiva",
  "shot.diff_normal": "Normal",
  "shot.difficulty": "Simpan Difficulty",
  "shot.goal": "Gol Tercipta",
  "shot.missed": "Tembakan Melebar",
  "shot.playType": "Play Type",
  "shot.playType_balon_parado": "Set Piece",
  "shot.playType_contra": "Contra",
  "shot.playType_jugada": "Jugada",
  "shot.playType_penalti": "Penalti",
  "shot.result": "Hasil Tembakan",
  "shot.result_bloqueado": "Bloqueado",
  "shot.result_fuera": "Fuera",
  "shot.result_gol": "Gol",
  "shot.result_parada": "Simpan",
  "shot.saved": "Tembakan Ditepis",
  "shot.step1": "1. Resultado",
  "shot.step2": "2. Dificultad",
  "shot.step3": "3. Comodidad",
  "shot.team": "Tim",
  "shot.team_own": "Propio",
  "shot.team_rival": "Rival",
  "shot.title": "Peta Tembakan",
  "shot.zone": "Shot Zone",
  "shot.zone_inside_center": "Center (Box)",
  "shot.zone_inside_left": "Left Wing (Box)",
  "shot.zone_inside_right": "Right Wing (Box)",
  "shot.zone_outside_center": "Centro (Fuera)",
  "shot.zone_outside_left": "Banda Izq. (Fuera)",
  "shot.zone_outside_right": "Banda Der. (Fuera)",
  "shot.zone_penalty": "Penalty Spot",
  "spell.addToDictionary": "Add ke dictionary",
  "spell.allCorrect": "Tidak spelling issues",
  "spell.ignore": "Ignorar",
  "spell.missingAccent": "Falta tilde",
  "spell.noSuggestions": "Tidak direct suggestions",
  "spell.observations": "{count} spelling observation",
  "spell.observationsPlural": "{count} spelling observations",
  "spell.recommended": "Sugerencias:",
  "spell.title": "Spelling & Grammar",
  "spell.typo": "Typo",
  "spell.unrecognized": "Palabra no reconocida",
  "staff.cancelInvitation": "Batal invitation",
  "staff.changeRole": "Cambiar Rol:",
  "staff.copied": "Disalin!",
  "staff.copy": "Copiar",
  "staff.copyCode": "Salin Kode",
  "staff.copyLink": "Copiar Enlace",
  "staff.copyLinkDesc": "Copy dan send ini link ke  staff member so they can join  tim:",
  "staff.createdDate": "Creada: {date}",
  "staff.generateLink": "⚡ Buat Tautan / Kode",
  "staff.inviteGenerated": "Undangan Dibuat!",
  "staff.inviteLinkCopied": "Tautan undangan disalin.",
  "staff.inviteModalDesc": "Enter  email address dan pilih  role.  user will be able ke access dan collaborate di real waktu.",
  "staff.inviteModalTitle": "Invite Pelatihing Staff Member",
  "staff.inviteStaffBtn": "Invitar Staff ({count}/{limit})",
  "staff.pendingInvitations": "Tertunda Invitations ({count})",
  "staff.realtimeSync": "Tim: {team} · Real-time sync",
  "staff.remove": "Quitar",
  "staff.removeConfirm": "Are you sure you want ke remove {nama} dari  coaching staff?",
  "staff.role.admin": "Head Pelatih (Admin)",
  "staff.role.analyst": "Taktis Analyst",
  "staff.role.assistant": "Assistant / 3rd Pelatih",
  "staff.role.assistantCoach": "Asisten Pelatih",
  "staff.role.coach": "Asisten Pelatih",
  "staff.role.collaborator": "Colaborador / Ayudante",
  "staff.role.coordinator": "Academy Director",
  "staff.role.delegate": "Tim Delegate",
  "staff.role.doctor": "Tim Doctor",
  "staff.role.fitness_coach": "Pelatih Fisik",
  "staff.role.goalkeeperCoach": "GolKiper Pelatih",
  "staff.role.headCoach": "Primer Entrenador",
  "staff.role.physicalTrainer": "Pelatih Fisik",
  "staff.role.physio": "Fisioterapis",
  "staff.role.player": "Pemain",
  "staff.role.scout": "Ojeador / Scout",
  "staff.roleAssistantCoach": "Asisten Pelatih",
  "staff.roleDesc.admin": "Full control: tim management, members, pertandingan, sesi, health, dan tactics.",
  "staff.roleDesc.analyst": "Real-waktu Live Stats recording dan analysis, reports, dan analytics.",
  "staff.roleDesc.assistant": "Live Stats recording, attendance tracking, dan sesi dukungan.",
  "staff.roleDesc.coach": "Match editing, lineups, sesi, whiteboard, planning, dan attendance.",
  "staff.roleDesc.fitness_coach": "Physical preparation, latihan loads, fitness tests, dan athletic status.",
  "staff.roleDesc.physio": "Akses dan pengeditan riwayat medis, cedera, tes fisik/kebugaran, dan kehadiran.",
  "staff.roleDesc.player": "Akses hanya-baca ke profil individu, sesi, dan kalender.",
  "staff.roleDoctor": "Dokter Tim",
  "staff.roleFitnessCoach": "Pelatih Fisik",
  "staff.roleGoalkeeperCoach": "Pelatih Kiper",
  "staff.roleHeadCoach": "Pelatih Kepala",
  "staff.roleLabel": "Role di Coaching Staff",
  "staff.rolePhysio": "Fisioterapis",
  "staff.roleScout": "Pemandu Bakat / Analis",
  "staff.sendInvite": "Send Invitation",
  "staff.shareCodeDesc": "Share ini code so pemain atau parents can join dari  Portal (/join-tim).",
  "staff.shareLink": "Compartir Enlace",
  "staff.shareNative": "📲 Compartir Enlace (WhatsApp / Apps)",
  "staff.sixDigitCode": "6-digit code:",
  "staff.staffTitle": "Pelatihing Staff & Collaborators",
  "staff.tab.active": "Staf Aktif",
  "staff.tab.invites": "Undangan",
  "staff.uniqueCodeTitle": "Unique Code for Pemain & Families",
  "staff.you": "(You)",
  "staffHeredado.badgeActive": "PRO features aktif via {ownerName}'s plan",
  "staffHeredado.badgeActiveShort": "Inherited Paket ({ownerName})",
  "staffHeredado.gracePeriodBanner": "Subscription Notice:  owner's plan has changed.  tim will enter restricted mode di {days} days. Upgrade ke PRO ke maintain full access.",
  "staffHeredado.gracePeriodBlocked": "Restricted Access:  tim grace period has expired.  owner must reactivate their PRO plan ke restore full staff privileges.",
  "staffHeredado.restrictedFeatureStaff": "This feature requires  tim ke have sebuah aktif PRO plan dari  owner.",
  "staffHeredado.transferError": "Error transferring tim ownership.",
  "staffHeredado.transferLimitExceeded": "This user already owns sebuah tim pada their Free plan. They must upgrade ke PRO ke accept ownership of ini tim.",
  "staffHeredado.transferSuccess": "Tim ownership transferred successfully to {userName}.",
  "staffInvite.cardSubtitle": "Exclusive code ke link assistants, fitness pelatih, dan analysts ke technical staff.",
  "staffInvite.cardTitle": "Akses CODE FOR PelatihES / STAFF",
  "staffInvite.codeCopied": "Staff code copied",
  "staffInvite.copyCode": "Copy Code",
  "staffInvite.copyLink": "Copiar Enlace",
  "staffInvite.downloadQr": "Unduh QR Image",
  "staffInvite.emailLabel": "Collaborator email Tambahress:",
  "staffInvite.inputPlaceholder": "e.g. ABC123 atau STF-ABC123",
  "staffInvite.inviteEmail": "Invite via Email",
  "staffInvite.joinBtn": "JOIN TEAM",
  "staffInvite.joinSubtitle": "If you were invited oleh  head pelatih, enter your code here.",
  "staffInvite.joinTitle": "Akses CODE FOR PelatihES / STAFF",
  "staffInvite.linkCopied": "Staff link copied",
  "staffInvite.messageLabel": "Invitation message:",
  "staffInvite.modalTitle": "Invite Teknis Staff Member",
  "staffInvite.qrCopied": "Enlace copiado",
  "staffInvite.qrModal": "Lihat QR de Staff",
  "staffInvite.qrModalTitle": "Staff QR Invitation Code",
  "staffInvite.qrSubtitle": "invited pelatih can scan ini QR code dengan their mobile device ke join  staff:",
  "staffInvite.roleLabel": "Rol asignado:",
  "staffInvite.sendBtn": "Send Invitation",
  "staffInvite.sendSuccess": "Invitation sent Berhasilfully.",
  "staffInvite.shareLink": "Compartir Enlace",
  "staffJoin.assignedRole": "Rol Asignado:",
  "staffJoin.btnSubmit": "Cari and Join",
  "staffJoin.confirmJoin": "Konfirmasi AND JOIN STAFF",
  "staffJoin.errors.invalidCode": "Invalid atau expired staff code. Contact  head pelatih.",
  "staffJoin.inputPlaceholder": "e.g. STF-ABC123 atau ABC123",
  "staffJoin.linkPlaceholder": "https://mister11.com/join-staff?code=ABC123",
  "staffJoin.orPasteLink": "Have sebuah invite link? Paste it here:",
  "staffJoin.searching": "Validating code di real waktu...",
  "staffJoin.subtitle": "Enter  6-character code provided oleh  head pelatih atau paste your invitation link.",
  "staffJoin.success": "You have successfully joined  Technical Staff!",
  "staffJoin.teamFound": "Tim Found:",
  "staffJoin.title": "Join Teknis Staff",
  "stats.eventMap.guide": "Spatial distribution of tim actions (recoveries, duels, shots, dan fouls). Highlights where  tim is working, winning duels, atau conceding ground pada  pitch.",
  "stats.eventMap.pass_insufficient": "Pass network unavailable: At least 5 recorded passes are required ke generate tactical passing links. Showing zone event distribution instead.",
  "stats.eventMap.title": "Zone Event Map",
  "stats.passNetwork.guide": "Each node represents sebuah pemain's average position dan line thickness reflects pass volume between teammates. It identifies key passing partnerships dan ball circulation dynamics.",
  "stats.theater.close": "Tutup theater mode",
  "stats.theater.exit_fullscreen": "Exit Fullscreen",
  "stats.theater.fullscreen": "Pantalla Completa",
  "stats.theater.theater_mode": "Modo Teatro",
  "status.none": "Sin Seleccionar",
  "swot.add_manual": "Tambah manual observation",
  "swot.ai_summary_title": "Taktis Ringkasan (AI)",
  "swot.auto_badge": "Regla",
  "swot.btn_generate_ai": "Draft summary dengan AI",
  "swot.generating_ai": "Drafting dengan AI...",
  "swot.manual_badge": "Manual",
  "swot.no_items": "No observations recorded untuk ini quadrant.",
  "swot.opportunities": "Peluang Taktis",
  "swot.origin_metric": "Origin metric",
  "swot.rule.central_box_leak": "Defensive vulnerability di  central corridor inside own box.",
  "swot.rule.counter_efficiency": "Constant danger dan rapid transitions pada counter attacks.",
  "swot.rule.duels_fragility": "Rendah duel win rate compromising midLapangan posSesi control.",
  "swot.rule.duels_superiority": "Territorial dominance dan authority di individual duels.",
  "swot.rule.gk_decisive_hero": "Decisive goalkeeping performance dengan high-merit crucial stops.",
  "swot.rule.gk_high_exertion": "High workload pada  goalkeeper due ke frequent opponent box entries.",
  "swot.rule.high_attendance_cohesion": "Excellent latihan attendance consistency dan tactical tim cohesion.",
  "swot.rule.high_xg_diff": "High attacking creation volume outperforming opponent di clear chances.",
  "swot.rule.late_fatigue": "Goals atau shots conceded di  final 15 menit indicate fatigue.",
  "swot.rule.low_xg_conv": "Chances created dengan low conversion rate, requiring finishing adjustments.",
  "swot.rule.rival_high_comfort": "Opponent shoots dengan excessive comfort tanpa immediate pressure.",
  "swot.rule.set_piece_threat": "Chances conceded pada set pieces require tighter defensive marking.",
  "swot.rule.wing_defense_solid": "Effective control of wide channels minimizing opponent danger.",
  "swot.strengths": "Kekuatan",
  "swot.threats": "Ancaman Lawan",
  "swot.title": "Matriz DAFO Trazable",
  "swot.weaknesses": "Kelemahan",
  "team.squadCount.one": "{count} pemain di skuad",
  "team.squadCount.other": "{count} pemain di skuad",
  "team.title": "My Tim",
  "teamMembers.admin_only_remove": "Only  Head Coach (Admin) can remove tim members.",
  "teamMembers.already_member": "This user is already sebuah member of  coaching staff.",
  "teamMembers.invite_cancelled": "Invitation Batalled.",
  "teamMembers.invite_generated": "Invitation link dan code generated successfully.",
  "teamMembers.member_removed": "Member removed dari coaching staff.",
  "teamMembers.role_updated": "Role updated ke {role}.",
  "teamQr.codeCopiedToast": "Tim code copied to clipboard",
  "teamQr.copied": "Copiado",
  "teamQr.copyCode": "Copy Code",
  "teamQr.downloadImage": "Unduh QR Image",
  "teamQr.linkCopiedToast": "Invitation link copied ke clipboard",
  "teamQr.modalTitle": "Tim QR Code and Access Link",
  "teamQr.scanInstructions": "Show ini QR code ke your pemain atau bagikan  direct link so they can join  tim:",
  "teamQr.shareLink": "Compartir Enlace",
  "teamQr.teamCodeLabel": "Access Code:",
  "test.answeringAll": "Please answer Semua questionnaire items.",
  "test.auto.acsi28.cat": "Coping dan Pressure",
  "test.auto.acsi28.desc": "Assesses your ability ke stay calm under errors, handle pressure dan focus during key pertandingan moments.",
  "test.auto.acsi28.name": "ACSI-28 (Afrontamiento Deportivo)",
  "test.auto.acsi28.q1": "I stay calm dan keep sebuah positive mindset even when  score is down.",
  "test.auto.acsi28.q2": "If I make sebuah mistake atau lose  ball, I let it go quickly dan focus pada  next play.",
  "test.auto.acsi28.q3": "I remain focused pada  game despite shouting atau outside noise.",
  "test.auto.acsi28.q4": "I can focus fully pada  tactical task requested oleh  head pelatih.",
  "test.auto.acsi28.q5": "I feel total confidence di my abilities before stepping onto  pitch.",
  "test.auto.acsi28.q6": "In crunch waktu atau decisive menit I play freely tanpa freezing.",
  "test.auto.acsi28.q7": "I accept pelatih feedback knowing it helps me develop as sebuah pemain.",
  "test.auto.acsi28.q8": "I adapt quickly if my pelatih changes my position atau role during  game.",
  "test.auto.acsi28.short": "ACSI-28",
  "test.auto.geq.cat": "Tim Spirit and Dressing Room",
  "test.auto.geq.desc": "Assesses squad unity, peer communication, dan belonging within  squad.",
  "test.auto.geq.name": "GEQ (Grup Environment Questionnaire)",
  "test.auto.geq.q1": "Everyone di  dressing room pulls together toward common targets.",
  "test.auto.geq.q2": "We encourage dan back each other up when someone makes sebuah mistake.",
  "test.auto.geq.q3": "There is sebuah healthy, positive atmosphere dan true fellowship off  pitch.",
  "test.auto.geq.q4": "I feel completely valued dan integrated di ini squad.",
  "test.auto.geq.short": "GEQ Cohesion",
  "test.auto.goals.cat": "Metas y Enfoque",
  "test.auto.goals.desc": "Evaluates how you plan technical dan physical goals ke improve week after week.",
  "test.auto.goals.name": "Gol Setting Scale",
  "test.auto.goals.q1": "I clearly know which technical atau fitness skills ke sharpen ini month.",
  "test.auto.goals.q2": "I give extra effort pada drills itu challenge me  most.",
  "test.auto.goals.q3": "I reflect pada pertandingan dan drills ke see what I can improve next waktu.",
  "test.auto.goals.short": "Individual Gols",
  "test.auto.mhc.cat": "PsychoSosial Well-Being",
  "test.auto.mhc.desc": "Assesses joy di playing, fulfillment, dan athletic progression.",
  "test.auto.mhc.name": "MHC-SF (Bienestar Emocional)",
  "test.auto.mhc.q1": "I truly enjoy dan feel happy every waktu I show up ke practice atau play.",
  "test.auto.mhc.q2": "I feel playing sports shapes me into sebuah better person dan builds discipline.",
  "test.auto.mhc.q3": "I enjoy sebuah trusting dan respectful relationship dengan  coaching staff.",
  "test.auto.mhc.short": "Bienestar Mental",
  "test.auto.mtq10.cat": "Fortaleza Mental",
  "test.auto.mtq10.desc": "Measures your grit, determination, dan how you turn challenging moments into growth opportunities.",
  "test.auto.mtq10.name": "MTQ-10 (Fortaleza y Resiliencia)",
  "test.auto.mtq10.q1": "I maintain emotional control when referee calls atau plays do not go as planned.",
  "test.auto.mtq10.q2": "I stick ke workouts dan physical sesi even pada low-motivation days.",
  "test.auto.mtq10.q3": "I view tough opponents dan challenges as chances ke prove my quality.",
  "test.auto.mtq10.q4": "I trust my capability ke bounce back dari slumps atau bench waktu.",
  "test.auto.mtq10.q5": "I never give up until  referee blows  final whistle.",
  "test.auto.mtq10.short": "Fortaleza MTQ",
  "test.auto.rpe.cat": "Physical Load dan Exertion",
  "test.auto.rpe.desc": "Log your perceived exertion after your latest practice atau pertandingan using  validated Borg 1-10 scale.",
  "test.auto.rpe.name": "RPE (Escala Borg CR-10)",
  "test.auto.rpe.q1": "What level of exertion atau physical intensity did you experience di your last sesi atau pertandingan?",
  "test.auto.rpe.short": "RPE Esfuerzo",
  "test.backToCatalog": "Kembali to test catalog",
  "test.category.aerobic": "Aerobik & Ketahanan",
  "test.category.anaerobic": "Daya Anaerobik",
  "test.category.flexibility": "Kelenturan",
  "test.category.speed": "Kecepatan & Sprint",
  "test.category.strength": "Kekuatan & Tenaga",
  "test.completedBadge": "Completado",
  "test.completedSuccess": "Tes {name} berhasil diselesaikan! ({pct}%)",
  "test.dim.belonging": "Pertenencia",
  "test.dim.challenge": "Challenge",
  "test.dim.coachability": "Entrenabilidad",
  "test.dim.commitment": "Compromiso",
  "test.dim.concentration": "Concentration",
  "test.dim.confidence": "Confianza",
  "test.dim.coping": "Afrontamiento",
  "test.dim.emotionalControl": "Control Emocional",
  "test.dim.goalClarity": "Goal Clarity",
  "test.dim.groupSupport": "Apoyo Grupal",
  "test.dim.perceivedEffort": "Esfuerzo Percibido",
  "test.dim.perseverance": "Perseverancia",
  "test.dim.purpose": "Purpose",
  "test.dim.selfAnalysis": "Self-Analysis",
  "test.dim.selfOvercoming": "Self-Improvement",
  "test.dim.socialCohesion": "Social Cohesion",
  "test.dim.sportsJoy": "Disfrute Deportivo",
  "test.dim.staffTrust": "Confianza Staff",
  "test.dim.taskCohesion": "Task Cohesion",
  "test.dim.underPressure": "Peak Performance under Tekanure",
  "test.dimension": "Dimension",
  "test.errorSaving": "Kesalahan saving test. Please try again.",
  "test.finishAndSend": "SELESAIKAN & KIRIM KE PELATIH",
  "test.initialEvaluationRegistered": "Initial evaluation recorded",
  "test.lastResult": "Last result",
  "test.of": "de",
  "test.opt.agree": "Agree",
  "test.opt.almostAlways": "Casi siempre",
  "test.opt.almostNever": "Casi nunca",
  "test.opt.always": "Siempre",
  "test.opt.disagree": "Disagree",
  "test.opt.little": "Slightly agree",
  "test.opt.mostTimes": "Most of  waktu",
  "test.opt.never": "Nunca",
  "test.opt.notAtAll": "Not di all agree",
  "test.opt.often": "A menudo",
  "test.opt.quite": "Moderately agree",
  "test.opt.quiteAgree": "Moderately agree",
  "test.opt.rarely": "Raras veces",
  "test.opt.rpe1": "1 - Very light (Pemulihan)",
  "test.opt.rpe10": "10 - Maximum effort (absolute peak)",
  "test.opt.rpe2": "2 - Light (comfortable)",
  "test.opt.rpe3": "3 - Moderate (steady aerobic)",
  "test.opt.rpe4": "4 - Somewhat hard (feeling Kelelahan)",
  "test.opt.rpe5": "5 - Hard (Pemberitahuanable effort)",
  "test.opt.rpe6": "6 - Bastante duro",
  "test.opt.rpe7": "7 - Very hard (Tinggi Intensitas)",
  "test.opt.rpe8": "8 - Sangat keras + (mendekati batas)",
  "test.opt.rpe9": "9 - Extenuante",
  "test.opt.sometimes": "A veces",
  "test.opt.somewhatDisagree": "Slightly agree",
  "test.opt.stronglyAgree": "Strongly agree",
  "test.opt.stronglyDisagree": "Strongly disagree",
  "test.previous": "Anterior",
  "test.question": "Pregunta",
  "test.questionProgress": "Question {current} of {Total}",
  "test.questionsCount": "{count} preguntas",
  "test.repeatTest": "Repetir Test",
  "test.retakeTest": "Repetir Cuestionario",
  "test.saveAnswers": "Simpan & Finish",
  "test.saving": "Menyimpan...",
  "test.startTest": "Iniciar Cuestionario",
  "test.successSaved": "Test selesai dan disimpan ke your file.",
  "test.tabSubtitle": "Complete ini questionnaires dari your mobile ke boost mindset, focus, dan tim cohesion.",
  "test.tabTitle": "Tests & Autoevaluaciones",
  "test.timeEstimate": "{minutes} min aprox.",
  "tests.alertResetConfirm": "Apakah Anda yakin ingin mengatur ulang data musim ini?",
  "tests.attention": "⚠️ ATTENTION",
  "tests.catalogPhysical": "Katalog Tes: FISIK",
  "tests.catalogPsychosocial": "Katalog Tes: PSIKOSOSIAL",
  "tests.confirm_delete": "Konfirmasi deletion",
  "tests.confirm_season_reset": "Reset Season",
  "tests.createTest": "+ Buat Tes",
  "tests.demoData": "🎯 Data Demo",
  "tests.demoDataTooltip": "Memasukkan evaluasi tiruan untuk melihat grafik",
  "tests.demoSuccess": "Data demo berhasil dimuat!",
  "tests.error": "Error",
  "tests.exportReport": "Ekspor Laporan",
  "tests.insert_demo": "Insertar datos demo",
  "tests.matrix.exportTeamReport": "Ekspor Laporan Tim",
  "tests.matrix.initialEval": "Eval Awal",
  "tests.matrix.latestEval": "Eval Terakhir",
  "tests.matrix.number": "Nomor",
  "tests.matrix.player": "Pemain",
  "tests.matrix.previousEval": "Eval Sebelumnya",
  "tests.matrix.progress": "Kemajuan",
  "tests.matrix.title": "MATRIKS PERENCANAAN",
  "tests.metricUnit": "Satuan: ",
  "tests.modal.cancel": "BATAL",
  "tests.modal.confirm": "SETUJU",
  "tests.modal.downloadTemplate": "Unduh Templat Pengumpulan Data",
  "tests.modal.execution": "Eksekusi:",
  "tests.modal.executionProtocol": "PROTOKOL EKSEKUSI",
  "tests.modal.goToRecord": "Pergi untuk Mencatat Hasil",
  "tests.modal.measurement": "Pengukuran:",
  "tests.modal.noProtocol": "Tidak ada protokol terperinci yang ditentukan untuk tes ini.",
  "tests.modal.objective": "Tujuan:",
  "tests.modal.objectiveDesc": "TUJUAN & DESKRIPSI",
  "tests.modal.recordTitle": "Catatan:",
  "tests.modal.rfefBadge": "Tolok Ukur Resmi RFEF (Persentil Putra & Putri)",
  "tests.modal.rfefTooltip": "Sumber: Federasi Sepak Bola Kerajaan Spanyol (RFEF) - Standar Kebugaran Fisik Sepak Bola Pembinaan Putri (Lompat Jauh Tanpa Awalan).",
  "tests.modal.unit": "Satuan ukuran:",
  "tests.modal.unitLabel": "Satuan: ",
  "tests.newModal.category": "Kategori Khusus",
  "tests.newModal.categoryPlaceholder": "Contoh: Daya Tahan, Psikologi...",
  "tests.newModal.desc": "Deskripsi Singkat",
  "tests.newModal.descPlaceholder": "Ringkasan tes",
  "tests.newModal.name": "Nama Tes",
  "tests.newModal.namePlaceholder": "Contoh: 1RM Squat",
  "tests.newModal.physical": "Fisik",
  "tests.newModal.protocol": "Protokol Pelaksanaan Lengkap",
  "tests.newModal.protocolPlaceholder": "Langkah tepat bagaimana tes dilakukan di lapangan...",
  "tests.newModal.psychosocial": "Psikososial",
  "tests.newModal.socioemotional": "Sosio-emosional",
  "tests.newModal.tactical": "Taktis",
  "tests.newModal.title": "Tes Baru",
  "tests.newModal.type": "Tipe Tes",
  "tests.newModal.unit": "Satuan Ukuran",
  "tests.newModal.unitPlaceholder": "Contoh: kg, dtk, poin",
  "tests.record": "CATAT",
  "tests.resetSeason": "🗑️ Reset Musim",
  "tests.resetSeasonTooltip": "Menghapus semua data evaluasi pemain untuk memulai musim baru",
  "tests.resources.drillDatabase": "Latihan",
  "tests.resources.myTeam": "Mi Plantilla",
  "tests.resources.seasonReport": "Season Report",
  "tests.resources.tacticalLibrary": "Papan Taktik",
  "tests.resources.tacticalTest": "Tactical Test",
  "tests.resources.teamChat": "Tim Chat",
  "tests.resources.title": "Sumber Daya & Alat",
  "tests.rpe.cancel": "BATAL",
  "tests.rpe.save": "SAVE RPE",
  "tests.saveResults": "Simpan Results",
  "tests.success": "Success",
  "tests.tab.comparativa": "Perbandingan",
  "tests.tab.fisicos": "Tes Fisik",
  "tests.tab.historial": "Riwayat",
  "tests.tab.prevencion": "Pencegahan & Kesehatan",
  "tests.tab.psicosociales": "Psikososial",
  "tests.template": "TEMPLAT",
  "tests.title": "EVALUASI & TES",
  "tests.validation": "Validation",
  "tests.wellness.save": "Simpan Evaluation",
  "wellness.fatigue": "Tingkat Kelelahan",
  "wellness.mood": "Suasana Hati",
  "wellness.rpe.cancel": "BATAL",
  "wellness.rpe.desc": "Record how {nama} perceived  effort.",
  "wellness.rpe.durationLabel": "Sesi Latihan duration (minutes)",
  "wellness.rpe.levelLabel": "Exertion Level (RPE 1-10)",
  "wellness.rpe.save": "SAVE RPE",
  "wellness.rpe.scaleMax": "10 - Maximum effort",
  "wellness.rpe.scaleMin": "1 - Muy suave",
  "wellness.rpe.title": "Rate of Perceived Exertion (RPE)",
  "wellness.rpe.trainingLoad": "Pelatihan Load (RPE × Durasi):",
  "wellness.sleep": "Kualitas Tidur",
  "wellness.soreness": "Nyeri Otot",
  "wellness.stress": "Tingkat Stres",
  "whiteboard.exportError": "Kesalahan Eksporing MP4 video. Please try again.",
  "whiteboard.exportRetry": "Retry export",
  "whiteboard.exportSuccess": "MP4 video EkspoMerah Berhasilfully.",
  "whiteboard.exportingFrame": "Eksporing frame {current} of {Total}...",
  "xg.box_center": "Central Box",
  "xg.box_wings": "Lateral Box",
  "xg.decisive_pct": "Decisive Berhasil %",
  "xg.decisive_saves": "Paradas Decisivas",
  "xg.demanding_match": "Demanding Pertandingan",
  "xg.desc": "Statistical goal probability based pada zone, comfort, dan play type.",
  "xg.exposure_map": "Defensive Exposure Map",
  "xg.gk_exertion": "GK Exertion Index",
  "xg.label": "Expected Goals (xG)",
  "xg.normal_match": "Exigencia Controlada",
  "xg.normal_saves": "Paradas Normales",
  "xg.outside_box": "Luar Kotak Penalti",
  "xg.own_xg": "xG Propio",
  "xg.penalty_box": "Penalti",
  "xg.rival_comfort": "Comodidad Rival",
  "xg.rival_xg": "xG Rival",
  "xg.save_pct": "Simpan Effectiveness %",
  "xg.title": "xG-Lite Model & Exposure",
  "xg.totalTeam": "Total xG Tim",
  "xg.total_saves": "Total Paradas",
  "clinical.fallbackChip": "konten klinis dalam bahasa Spanyol",
  "landing.footer.languages": "Bahasa",
  "landing.footer.rights": "Hak cipta dilindungi undang-undang.",
  "landing.hero.badge": "OTAK DIGITAL PELATIH",
  "landing.hero.btnPrimary": "COBA GRATIS 7 HARI",
  "landing.hero.btnSecondary": "LIHAT PAKET & TARIF",
  "landing.hero.desc": "Papan taktik interaktif, pencatatan langsung dengan proporsi lapangan regulasi FIFA 105:68, pencegahan cedera dengan AI, tes psikometri tervalidasi, dan lembar pertandingan resmi dalam PDF.",
  "landing.hero.title_highlight": "tingkat profesional",
  "landing.hero.title_part1": "Tingkatkan metodologi latihan Anda ke",
  "landing.nav.login": "MASUK",
  "landing.nav.selectLang": "Pilih bahasa",
  "landing.nav.themeToggle": "Beralih tema",
  "landing.preview.title": "Papan Taktik Mister11 · Lapangan dan Pion",
  "landing.trust.noCard": "Tanpa kartu kredit",
  "landing.trust.platforms": "Web, PWA dan Android",
  "landing.trust.trial": "7 hari uji coba penuh",
  "pricing.toggle.monthly": "Bulanan",
  "pricing.toggle.season": "Tiket Musim (Disarankan)",
  "pdf.trainingSheet": "LEMBAR LATIHAN",
  "pdf.date": "TANGGAL",
  "pdf.time": "WAKTU",
  "pdf.duration": "DURASI",
  "pdf.intensity": "INTENSITAS",
  "pdf.category": "KATEGORI",
  "pdf.material": "PERALATAN",
  "pdf.blocks": "BLOK",
  "pdf.mainTacticalDiagram": "DIAGRAM TAKTIK UTAMA",
  "pdf.trainingBlocks": "BLOK LATIHAN",
  "pdf.convocation": "DAFTAR PEMAIN",
  "pdf.postSessionNotes": "CATATAN PASCA-LATIHAN",
  "pdf.notesEmpty": "Tidak ada catatan",
  "pdf.myTeam": "Tim Saya",
  "pdf.footerBrand": "Mister11 Platform - mister11.app",
  "pdf.pageOf": "Halaman {cur} dari {total}",
  "pdf.objectivePrefix": "Tujuan: ",
  "player.greet.hello": "Halo!",
  "player.join": "Gabung dengan Kode",
  "player.ach.unlocked": "TERBUKA",
  "player.tier.bronze": "Perunggu",
  "player.tier.silver": "Perak",
  "player.tier.gold": "Emas",
  "player.period.biweekly": "Dua minggu ini",
  "player.profile.dominantFoot": "Kaki dominan: {foot}",
  "player.profile.rightFoot": "Kanan",
  "player.profile.leftFoot": "Kiri",
  "player.profile.ambidextrous": "Ambidextrous",
  "player.consent.signEdit": "Tanda Tangani / Edit Persetujuan",
  "player.auth.switchToCoach": "Beralih ke Mode Pelatih",
  "player.auth.logout": "Keluar",
  "player.auth.deleteAccount": "Hapus Akun & Data (GDPR)",
  "player.games.healthyTraining": "LATIHAN SEHAT",
  "player.games.homeChallenges": "Tantangan di Rumah",
  "player.games.reactionSpeed": "KECEPATAN REAKSI",
  "player.games.workingMemory": "MEMORI KERJA",
  "player.games.tacticalReading": "PEMBACAAN TAKTIKAL",
  "player.games.play": "MAIN",
  "player.wellness.dailyCheckin": "CHECK-IN KEBUGARAN HARIAN",
  "player.wellness.saveCheckin": "KIRIM CHECK-IN HARIAN",
  "player.wellness.updateCheckin": "PERBARUI STATUS UMUM",
  "player.wellness.medicalHistory": "Riwayat Medis & Cedera",
  "player.wellness.recordInjury": "CATAT KELUHAN ATAU CEDERA",
  "player.plans.individualPlans": "Rencana Pelatihan Individu",
  "player.plans.evolutionConstancy": "EVOLUSI DAN KONSISTENSI",
  "player.plans.activeCount": "{count} Rencana Aktif",
  "player.plans.allUpToDate": "Semua rencana sudah mutakhir!",
  "player.ach.tabs.vitrina": "Etalase",
  "player.ach.tabs.games": "Permainan & Tantangan",
  "player.ach.tabs.ranking": "Peringkat",
  "player.schedule.prevMonth": "Bulan sebelumnya",
  "player.schedule.nextMonth": "Bulan berikutnya",
  "player.schedule.calledUpTitle": "Dipanggil untuk pertandingan!",
  "player.schedule.reserveTitle": "Daftar tunggu / Cadangan",
  "player.schedule.notCalledTitle": "Tidak dipanggil untuk pertandingan ini",
  "player.schedule.played": "dimainkan",
  "player.schedule.sheetClosed": "Lembar pertandingan resmi ditutup",
  "player.schedule.officialMinutes": "Menit resmi: {min}'",
  "player.schedule.dnp": "Tidak bermain dalam pertandingan ini",
  "player.schedule.parentPrompt": "Apakah {name} akan menghadiri acara ini?",
  "player.schedule.playerPrompt": "Apakah Anda akan menghadiri sesi ini?",
  "player.schedule.officialRecorded": "Kehadiran resmi dicatat oleh staf pelatih",
  "player.schedule.pendingVerificationDesc": "Sesi selesai, menunggu verifikasi pelatih",
  "player.schedule.parentTrainingPrompt": "Apakah {name} akan menghadiri latihan ini?",
  "player.schedule.playerTrainingPrompt": "Apakah Anda akan menghadiri sesi latihan ini?",
  "player.schedule.photosCaptures": "Foto & Dokumentasi Acara",
  "player.schedule.noEventsDesc": "Pelatih belum menjadwalkan sesi atau pertandingan untuk bulan ini.",
  "player.plans.active": "Aktif",
  "player.plans.progressionHabit": "PROGRES DAN KEBIASAAN",
  "player.plans.activePlan": "Rencana Aktif",
  "player.plans.activePlans": "Rencana Aktif",
  "player.plans.youth": "Usia Muda",
  "player.plans.monitoring": "Pemantauan",
  "player.plans.loading": "Memuat rencana latihan Anda...",
  "player.plans.upToDate": "Semua persiapan latihan sudah mutakhir!",
  "player.plans.techRoutine": "Rutinitas Teknis dan Pencegahan",
  "player.plans.defaultPlanTitle": "Rencana Pengembangan Individu",
  "player.plans.coachInstructions": "Instruksi Pelatih:",
  "player.plans.todayExercises": "Latihan untuk Hari Ini:",
  "player.plans.doneCount": "selesai",
  "player.plans.markPending": "Tandai belum selesai",
  "player.plans.viewGuide": "Lihat panduan teknis",
  "player.plans.guide": "Panduan",
  "player.plans.notAgeSafe": "Tidak sesuai untuk usia Anda",
  "player.plans.ageSafeTooltip": "Latihan ini memerlukan usia minimal {minAge} tahun demi keamanan biomekanik.",
  "player.stats.evaluation": "Evaluasi",
  "player.stats.general": "Umum",
  "player.stats.session": "Sesi",
  "player.stats.starter": "Starter",
  "player.stats.sub": "Cadangan",
  "player.stats.pendingSheet": "Menunggu lembar resmi",
  "player.stats.coachRating": "Nilai Pelatih",
  "player.stats.attitude": "Sikap",
  "player.stats.hitsVsMisses": "Berhasil vs Gagal",
  "player.stats.shotsOnTarget": "Tembakan tepat sasaran / total",
  "player.stats.duelsWon": "Duel dimenangkan / total",
  "player.stats.recoveriesLosses": "Rebut bola vs Kehilangan bola",
  "player.stats.fouls": "pelanggaran",
  "player.stats.bestStat": "Statistik terbaik Anda pertandingan ini",
  "player.stats.youVsAverage": "Anda vs Rata-rata Musim Anda",
  "player.stats.areasPending": "Area menunggu pengukuran",
  "player.stats.activeDiscomfort": "Keluhan aktif",
  "player.stats.available100": "100% Siap",
  "player.stats.dailyProgression": "Perkembangan Harian (7 check-in terakhir)",
  "player.stats.pain": "Nyeri",
  "player.stats.ok": "OK",
  "player.stats.cleanSheet": "Clean Sheet",
  "player.chat.defaultPlayerName": "pemain ini",
  "player.home.defaultRole": "Pemain",
  "player.home.defaultCrack": "Bintang",
  "player.home.calledUpSquad": "Anda masuk dalam daftar panggilan resmi pertandingan ini!",
  "player.home.defaultLocation": "Lapangan Latihan",
  "stats.singleMatch": "1 pertandingan",
  "stats.partidos": "pertandingan",
  "player.home.staffAuthor": "Staf Pelatih",
  "player.home.recent": "Baru saja",
  "player.banner.perfProfile": "PROFIL PERFORMA",
  "player.banner.noTestData": "Belum ada data evaluasi",
  "player.banner.perfMedal": "MEDALI PERFORMA",
  "player.profile.securityReauth": "Demi alasan keamanan, Anda harus keluar dan masuk kembali sebelum menghapus akun Anda.",
  "player.profile.deleteAccountError": "Tidak dapat menghapus akun. Silakan hubungi kami atau coba lagi setelah memulai ulang sesi.",
  "player.profile.matchesPlayedShort": "Main",
  "player.profile.defaultCategory": "Usia Muda",
  "player.profile.accountFallback": "Akun Pemain",
  "player.wellness.saving": "Menyimpan...",
  "player.consent.parentPlaceholder": "Contoh: Carlos Caicedo Perez",
  "player.settings.notifDenied": "Izin notifikasi ditolak.",
  "player.settings.remindersActivated": "Pengingat diaktifkan.",
  "player.settings.languageUpdated": "Bahasa diperbarui",
  "player.settings.confirmLogout": "Apakah Anda ingin keluar?",
  "player.settings.toggleTheme": "Beralih tema terang/gelap",
  "player.settings.toggleNotif": "Beralih notifikasi",
  "test.name.cooper": "Tes Cooper",
  "test.cat.endurance": "Fisik · Daya Tahan",
  "test.name.navette": "Course Navette",
  "test.name.sprint10": "Sprint 10m",
  "test.cat.speed": "Fisik · Kecepatan",
  "test.name.sprint30": "Sprint 30m",
  "test.name.ttest": "T-Test (Kelincahan)",
  "test.cat.agility": "Fisik · Kelincahan",
  "test.name.cmj": "Lompatan CMJ",
  "test.cat.power": "Fisik · Kekuatan",
  "test.name.cones": "Dribel kerucut",
  "test.cat.ballControl": "Teknik · Kontrol",
  "test.name.shooting": "Umpan ke gawang",
  "test.cat.accuracy": "Teknik · Akurasi",
  "test.name.acsi28": "ACSI-28 (Keterampilan Mengatasi)",
  "test.cat.pressure": "Mental · Tekanan",
  "test.name.mtq10": "MTQ-10 (Ketangguhan Mental)",
  "test.cat.resilience": "Mental · Ketangguhan",
  "test.name.goals": "Penetapan Tujuan",
  "test.cat.goals": "Mental · Sasaran",
  "test.name.leadership": "Kepemimpinan & Komunikasi",
  "test.cat.leadership": "Mental · Kepemimpinan",
  "test.name.geq": "GEQ (Kohesi Tim)",
  "test.cat.cohesion": "Sosial · Kohesi",
  "test.name.mhc": "Skala Kesejahteraan Mental",
  "test.cat.wellbeing": "Mental · Kesejahteraan",
  "test.name.emotions": "Kesadaran Emosional",
  "test.cat.emotions": "Mental · Emosi",
  "player.stats.pendingOfficialSheet": "Menunggu konfirmasi resmi — Statistik akan muncul setelah lembar pertandingan ditutup.",
  "stats.goles": "Gol",
  "stats.asistencias": "Assist",
  "stats.minutos": "Menit",
  "player.stats.goalsThisMatch": "Gol pertandingan ini",
  "player.stats.minutesThisMatch": "Menit pertandingan ini",
  "player.stats.avgShort": "rata-rata",
  "player.stats.avgLabel": "Rata-rata",
  "player.stats.coachMessage": "Pesan Pelatih",
  "player.stats.discipline": "Disiplin",
  "player.stats.lastEval": "Evaluasi terakhir:",
  "player.tab.technical": "Teknik",
  "player.tab.tactical": "Taktik",
  "player.stats.trainingRatingDesc": "Nilai teknis dalam sesi latihan",
  "player.stats.pendingRatings": "Menunggu penilaian",
  "player.stats.noRatingsYet": "Belum ada penilaian sesi latihan",
  "player.stats.ratingsInfoDesc": "Staf pelatih dapat menilai performa dan memberikan catatan teknis setelah setiap latihan dari modul Sesi.",
  "player.stats.weeklyWellness": "KEBUGARAN & PEMULIHAN MINGGUAN",
  "player.stats.last7Days": "7 hari terakhir",
  "player.stats.sleepQuality": "KUALITAS TIDUR",
  "player.stats.energyMood": "ENERGI / SUASANA HATI",
  "player.stats.muscleStatus": "STATUS OTOT",
  "player.profile.sectionsAria": "Bagian profil pemain",
  "player.banner.viewFullAnalytics": "Lihat analitik lengkap",
  "player.banner.techSummary": "Ringkasan teknis",
  "player.banner.renewTests": "Perbarui kuesioner dan tes",
  "player.wellness.synced": "Tersinkronisasi",
  "player.wellness.offlinePending": "Menunggu sinkronisasi",
  "games.level.bronce": "Perunggu",
  "games.level.plata": "Perak",
  "games.level.oro": "Emas",
  "games.level.diamante": "Berlian",
  "games.level.leyenda": "Legenda",
  "games.levelUp": "Anda naik ke level {level}! (+10 XP)",
  "games.levelCeiling": "Anda telah mencapai puncak Legenda!",
  "games.g3.opponent": "Lawan",
  "games.g3.teammate": "Rekan Setim",
  "exercise.level": "Tingkat"
};

export default id;
